/* DesignPrinz B2B-Konfigurator · T-Shirt, Poloshirt, Sweatshirt und Softshelljacke · 2026-09-02.5 */
class DPB2BConfigurator {
    constructor(element) {
        this.element = element;
        this.minimumQuantity = Number(element.dataset.minimumQuantity || 1);
        this.startOfferQuantity = Number(
            element.dataset.startOfferQuantity || 10
        );
        this.sectionId = String(element.dataset.sectionId || '');
        this.productUrl = String(element.dataset.productUrl || window.location.pathname);
        this.productModel = String(
            element.dataset.productModel || "SOL'S Imperial 190"
        );
        this.productLabel = String(element.dataset.productLabel || 'T-Shirt');
        this.productLabelPlural = String(
            element.dataset.productLabelPlural || 'T-Shirts'
        );
        this.frontPrintLabel = String(
            element.dataset.frontPrintLabel || 'Vorderseite'
        );
        this.defaultComposition = String(
            element.dataset.defaultComposition || '100 % Baumwolle'
        );
        this.greyComposition = String(
            element.dataset.greyComposition || '85 % Baumwolle, 15 % Viskose'
        );
        this.ashComposition = String(
            element.dataset.ashComposition || '98 % Baumwolle, 2 % Viskose'
        );

        this.colorButtons = Array.from(
            element.querySelectorAll('[data-color-button]')
        );

        this.sizeGroups = Array.from(
            element.querySelectorAll('[data-size-group]')
        );

        this.quantityInputs = Array.from(
            element.querySelectorAll('[data-quantity-input]')
        );

        this.printPositionInputs = Array.from(
            element.querySelectorAll('[data-print-position]')
        );

        this.totalQuantityElement = element.querySelector('[data-total-quantity]');
        this.minimumWarning = element.querySelector('[data-minimum-warning]');
        this.minimumProgress = element.querySelector('[data-minimum-progress]');
        this.minimumProgressText = element.querySelector(
            '[data-minimum-progress-text]'
        );
        this.minimumProgressStatus = element.querySelector(
            '[data-minimum-progress-status]'
        );
        this.minimumProgressBar = element.querySelector(
            '[data-minimum-progress-bar]'
        );
        this.priceTierElement = element.querySelector('[data-price-tier]');
        this.unitPriceElement = element.querySelector('[data-unit-price]');
        this.totalPriceElement = element.querySelector('[data-total-price]');
        this.basePriceElement = element.querySelector('[data-base-price]');
        this.surchargePriceElement = element.querySelector('[data-surcharge-price]');
        this.subtotalPriceElement = element.querySelector('[data-subtotal-price]');
        this.vatPriceElement = element.querySelector('[data-vat-price]');
        this.grossTotalPriceElement = element.querySelector('[data-gross-total-price]');
        this.projectStatusElement = element.querySelector('[data-project-status]');
        this.projectTextileElement = element.querySelector('[data-project-textile]');
        this.projectPrintElement = element.querySelector('[data-project-print]');
        this.projectQuantityElement = element.querySelector('[data-project-quantity]');
        this.projectUnitPriceElement = element.querySelector(
            '[data-project-unit-price]'
        );
        this.projectTotalPriceElement = element.querySelector(
            '[data-project-total-price]'
        );
        this.projectCompactPriceElement = element.querySelector(
            '[data-project-compact-price]'
        );
        this.projectTierMessageElement = element.querySelector(
            '[data-project-tier-message]'
        );

        this.productionTimeElement = element.querySelector('[data-production-time]');
        this.shippingTimeElement = element.querySelector('[data-shipping-time]');
        this.deliveryTimeElement = element.querySelector('[data-delivery-time]');

        this.summaryElement = element.querySelector('[data-order-summary]');
        this.summaryEmptyElement = element.querySelector('[data-summary-empty]');
        this.summaryBodyElement = element.querySelector('[data-summary-body]');
        this.summaryPrintPositionElement = element.querySelector(
            '[data-summary-print-position]'
        );
        this.summaryPrintDescriptionElement = element.querySelector(
            '[data-summary-print-description]'
        );
        this.summarySurchargeNote = element.querySelector(
            '[data-summary-surcharge-note]'
        );
        this.summaryArtwork = element.querySelector('[data-summary-artwork]');
        this.summaryEmail = element.querySelector('[data-summary-email]');
        this.summaryTeeinblueStatus = element.querySelector(
            '[data-summary-teeinblue-status]'
        );

        this.printEmailCheckbox = element.querySelector('[data-print-email]');
        this.artworkMethodButtons = Array.from(
            element.querySelectorAll('[data-artwork-method]')
        );
        this.artworkEmailHelp = element.querySelector(
            '[data-artwork-email-help]'
        );
        this.uploadSideControl = element.querySelector(
            '[data-upload-side-control]'
        );
        this.uploadSideButtons = Array.from(
            element.querySelectorAll(
                '[data-upload-side-control] [data-preview-side]'
            )
        );
        this.uploadSideStatuses = Array.from(
            element.querySelectorAll('[data-upload-side-status]')
        );
        this.uploadActiveSide = element.querySelector(
            '[data-upload-active-side]'
        );
        this.uploadNextSideButton = element.querySelector(
            '[data-upload-next-side]'
        );
        this.printNotesInput = element.querySelector('[data-print-notes]');
        this.artworkMessage = element.querySelector('[data-artwork-message]');
        this.backgroundTreatmentInputs = Array.from(
            element.querySelectorAll('[data-background-treatment]')
        );
        this.backgroundTreatmentSelect = element.querySelector(
            '[data-background-treatment-select]'
        );
        this.summaryBackgroundTreatment = element.querySelector(
            '[data-summary-background-treatment]'
        );

        this.addToCartButton = element.querySelector('[data-add-to-cart]');
        this.cartButtonText = element.querySelector('[data-cart-button-text]');
        this.cartLoader = element.querySelector('[data-cart-loader]');
        this.cartMessage = element.querySelector('[data-cart-message]');
        this.downloadOfferButton = element.querySelector('[data-download-offer]');
        this.mobileCartBar = element.querySelector('[data-mobile-cart-bar]');
        this.mobileQuantityElement = element.querySelector('[data-mobile-quantity]');
        this.mobileTotalElement = element.querySelector('[data-mobile-total]');
        this.mobileCartStatus = element.querySelector('[data-mobile-status]');
        this.mobileAddToCartButton = element.querySelector(
            '[data-mobile-add-to-cart]'
        );
        this.mobileCartButtonText = element.querySelector(
            '[data-mobile-cart-button-text]'
        );
        this.mobileCartLoader = element.querySelector('[data-mobile-cart-loader]');
        this.priceCard = element.querySelector('.dp-b2b__price-card');
        this.mobilePriceToggle = element.querySelector('[data-mobile-price-toggle]');

        this.shirtPreviewName = element.querySelector('[data-shirt-preview-name]');
        this.shirtPreviewProduct = element.querySelector(
            '[data-shirt-preview-product]'
        );

        this.teeinbluePreview = element.querySelector('[data-teeinblue-preview]');
        this.projectPreviewToggle = element.querySelector(
            '[data-project-preview-toggle]'
        );
        this.teeinblueGallery = element.querySelector('[data-teeinblue-gallery]');
        this.previewSideControl = element.querySelector(
            '[data-preview-side-control]'
        );
        this.previewSideButtons = Array.from(
            element.querySelectorAll('[data-preview-side]')
        );
        this.teeinblueFormContainer = element.querySelector('[data-teeinblue-form]');
        this.teeinblueUploadArea = element.querySelector(
            '[data-teeinblue-upload-area]'
        );
        this.teeinblueGalleryLoading = element.querySelector(
            '[data-teeinblue-gallery-loading]'
        );
        this.teeinblueFormLoading = element.querySelector(
            '[data-teeinblue-form-loading]'
        );
        this.teeinblueVariantSelect = element.querySelector(
            '[data-teeinblue-variant-select]'
        );
        this.variantBridgeForm = element.querySelector(
            '[data-variant-bridge-form]'
        );
        this.variantBridgeQuantity = element.querySelector(
            '[data-variant-bridge-quantity]'
        );

        this.uploadContextTitle = element.querySelector(
            '[data-upload-context-title]'
        );
        this.uploadContextText = element.querySelector('[data-upload-context-text]');

        this.sizeChartDialog = element.querySelector('[data-size-chart-dialog]');
        this.sizeChartOpenButton = element.querySelector('[data-size-chart-open]');
        this.sizeChartCloseButton = element.querySelector('[data-size-chart-close]');

        this.currentPreviewButton =
            this.colorButtons.find((button) => {
                return button.classList.contains('is-selected');
            }) ||
            this.colorButtons[0] ||
            null;

        this.currentMainVariant = null;
        this.currentResolvedVariant = null;
        this.isAddingToCart = false;
        this.teeinblueSyncTimer = null;
        this.teeinblueStateTimer = null;
        this.teeinblueObserver = null;
        this.lastTeeinblueRoot = null;
        this.lastTeeinblueSyncKey = '';
        this.previewSide = 'front';
        this.currentPreviewVariant = null;
        this.lastGalleryVariantId = '';
        this.isPreparingCartVariant = false;
        this.artworkCompletionBySide = {
            front: false,
            back: false
        };

        this.variants = this.readVariants();
        this.optionMap = this.readJsonScript(
            '[data-product-option-map]',
            { options: [] }
        );
        this.currentResolvedVariant = this.readJsonScript(
            '[data-resolved-variant]',
            null
        );
        this.variantResolutionCache = new Map();

        this.reorderConfigurationSteps();
        this.reorderCheckoutBlocks();
        this.setupPersistentProjectPreview();
        this.bindEvents();
        this.setupMobileCartBar();
        this.setupMobileStepAccordion();
        this.observeTeeinblue();
        this.installTeeinblueHooks();
        this.updateActivePreviewColor();
        this.updateArtworkVisibility();
        this.updatePreviewSideControl();
        this.updateUploadContext();
        this.updateAll();
    }

    readVariants() {
        const script = this.element.querySelector('[data-product-variants]');

        if (!script) {
            return [];
        }

        try {
            return JSON.parse(script.textContent);
        } catch (error) {
            console.error('B2B-Varianten konnten nicht gelesen werden.', error);
            return [];
        }
    }

    readJsonScript(selector, fallback) {
        const script = this.element.querySelector(selector);

        if (!script) {
            return fallback;
        }

        try {
            return JSON.parse(script.textContent);
        } catch (error) {
            console.error(
                `Konfigurationsdaten konnten nicht gelesen werden: ${selector}`,
                error
            );
            return fallback;
        }
    }

    reorderConfigurationSteps() {
        const artworkStep = this.element.querySelector(
            '[data-config-step="artwork"]'
        );
        const colorsStep = this.element.querySelector(
            '[data-config-step="colors"]'
        );

        if (
            artworkStep &&
            colorsStep &&
            artworkStep.parentElement === colorsStep.parentElement &&
            artworkStep !== colorsStep.previousElementSibling
        ) {
            artworkStep.parentElement.insertBefore(artworkStep, colorsStep);
        }
    }

    reorderCheckoutBlocks() {
        const cartArea = this.element.querySelector('.dp-b2b__cart-area');
        const trustBlock = this.element.querySelector('.dp-b2b__trust');

        if (
            cartArea &&
            trustBlock &&
            cartArea.parentElement === trustBlock.parentElement &&
            (
                trustBlock.compareDocumentPosition(cartArea) &
                Node.DOCUMENT_POSITION_FOLLOWING
            )
        ) {
            cartArea.parentElement.insertBefore(cartArea, trustBlock);
        }
    }

    setupPersistentProjectPreview() {
        if (!this.teeinbluePreview) {
            return;
        }

        const inner = this.element.querySelector('.dp-b2b__inner');

        if (!inner || inner.querySelector('[data-project-workspace]')) {
            return;
        }

        const firstStep = Array.from(inner.children).find((child) => {
            return child.matches?.('.dp-b2b__step');
        });

        if (!firstStep) {
            return;
        }

        const workspace = document.createElement('div');
        const previewColumn = document.createElement('aside');
        const workflowColumn = document.createElement('div');

        workspace.className = 'dp-b2b__project-workspace';
        workspace.dataset.projectWorkspace = '';
        previewColumn.className = 'dp-b2b__project-preview-column';
        previewColumn.setAttribute('aria-label', 'Live-Vorschau Ihres Textils');
        workflowColumn.className = 'dp-b2b__project-workflow';

        inner.insertBefore(workspace, firstStep);
        workspace.append(previewColumn, workflowColumn);
        previewColumn.append(this.teeinbluePreview);

        Array.from(inner.children).forEach((child) => {
            if (child === workspace) {
                return;
            }

            if (
                child.matches?.(
                    '.dp-b2b__step, .dp-b2b__checkout-overview, .dp-b2b__cart-area, .dp-b2b__trust'
                )
            ) {
                workflowColumn.append(child);
            }
        });
    }

    selectArtworkSide(side) {
        if (side !== 'front' && side !== 'back') {
            return;
        }

        if (
            !this.isDoublePrintPosition(
                this.getSelectedPrintPosition()
            )
        ) {
            return;
        }

        if (this.previewSide === side) {
            this.updatePreviewSideControl();
            this.updateUploadContext();
            return;
        }

        this.captureArtworkCompletion();
        this.previewSide = side;
        this.lastTeeinblueSyncKey = '';
        this.updatePreviewSideControl();
        this.updateUploadContext();
        this.scheduleTeeinblueSync(true);
    }

    bindEvents() {
        this.colorButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.toggleColor(button);
            });
        });

        this.quantityInputs.forEach((input) => {
            input.addEventListener('focus', () => {
                this.setPreviewColorByHandle(input.dataset.colorHandle || '');
            });

            input.addEventListener('input', () => {
                this.sanitizeQuantity(input);
                this.setPreviewColorByHandle(input.dataset.colorHandle || '');
                this.updateAll();
            });

            input.addEventListener('change', () => {
                this.sanitizeQuantity(input);
                this.setPreviewColorByHandle(input.dataset.colorHandle || '');
                this.updateAll();
            });
        });

        this.printPositionInputs.forEach((input) => {
            input.addEventListener('change', () => {
                this.captureArtworkCompletion();

                const selectedPosition = this.getSelectedPrintPosition();

                if (this.isDoublePrintPosition(selectedPosition)) {
                    this.previewSide = 'front';
                } else if (this.isBackPrintPosition(selectedPosition)) {
                    this.previewSide = 'back';
                } else {
                    this.previewSide = 'front';
                }

                this.lastTeeinblueSyncKey = '';
                this.updatePreviewSideControl();
                this.updateUploadContext();
                this.updateAll();
            });
        });

        this.previewSideButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this.selectArtworkSide(button.dataset.previewSide);
            });
        });

        if (this.uploadNextSideButton) {
            this.uploadNextSideButton.addEventListener('click', () => {
                this.selectArtworkSide('back');
            });
        }

        if (this.printEmailCheckbox) {
            this.printEmailCheckbox.addEventListener('change', () => {
                this.updateArtworkVisibility();
                this.updateAll();
            });
        }

        this.artworkMethodButtons.forEach((button) => {
            button.addEventListener('click', () => {
                if (!this.printEmailCheckbox) {
                    return;
                }

                const useEmail = button.dataset.artworkMethod === 'email';

                if (this.printEmailCheckbox.checked === useEmail) {
                    this.updateArtworkVisibility();
                    return;
                }

                this.printEmailCheckbox.checked = useEmail;
                this.printEmailCheckbox.dispatchEvent(
                    new Event('change', { bubbles: true })
                );
            });
        });

        if (this.printNotesInput) {
            this.printNotesInput.addEventListener('input', () => {
                this.updateAll();
            });
        }

        this.backgroundTreatmentInputs.forEach((input) => {
            input.addEventListener('change', () => {
                if (input.checked && this.backgroundTreatmentSelect) {
                    this.backgroundTreatmentSelect.value = input.value;
                }

                this.updateAll();
            });
        });

        if (this.backgroundTreatmentSelect) {
            this.backgroundTreatmentSelect.addEventListener('change', () => {
                const matchingInput = this.backgroundTreatmentInputs.find((input) => {
                    return input.value === this.backgroundTreatmentSelect.value;
                });

                if (matchingInput) {
                    matchingInput.checked = true;
                }

                this.updateAll();
            });
        }

        if (this.addToCartButton) {
            this.addToCartButton.addEventListener('click', () => {
                this.addConfigurationToCart();
            });
        }

        if (this.mobileAddToCartButton) {
            this.mobileAddToCartButton.addEventListener('click', () => {
                this.addConfigurationToCart();
            });
        }

        if (this.downloadOfferButton) {
            this.downloadOfferButton.addEventListener('click', () => {
                this.downloadOfferAsPdf();
            });
        }

        if (this.mobilePriceToggle && this.priceCard) {
            this.mobilePriceToggle.addEventListener('click', () => {
                const isExpanded = this.priceCard.classList.toggle('is-mobile-expanded');

                this.mobilePriceToggle.setAttribute(
                    'aria-expanded',
                    String(isExpanded)
                );
                this.mobilePriceToggle.textContent = isExpanded
                    ? 'Preisdetails ausblenden'
                    : 'Preisdetails anzeigen';
            });
        }

        if (this.projectPreviewToggle && this.teeinbluePreview) {
            /*
              * Der Listener sitzt bewusst auf dem stabilen Konfigurator-Element und
              * läuft in der Capture-Phase. Teeinblue baut Teile der Vorschau nach dem
              * Laden neu auf und kann mobile Klicks sonst abfangen.
              */
            this.element.addEventListener(
                'click',
                (event) => {
                    const eventTarget = event.target;

                    if (!(eventTarget instanceof Element)) {
                        return;
                    }

                    const toggleButton = eventTarget.closest(
                        '[data-project-preview-toggle]'
                    );

                    if (!toggleButton || !this.element.contains(toggleButton)) {
                        return;
                    }

                    event.preventDefault();

                    const currentPreview = this.element.querySelector(
                        '[data-teeinblue-preview]'
                    );

                    if (!currentPreview) {
                        return;
                    }

                    const isExpanded = currentPreview.classList.toggle(
                        'is-mobile-expanded'
                    );

                    currentPreview.closest('.dp-b2b__project-preview-column')
                        ?.classList.toggle('is-mobile-expanded', isExpanded);

                    toggleButton.setAttribute('aria-expanded', String(isExpanded));
                    toggleButton.textContent = isExpanded
                        ? 'Vorschau verkleinern'
                        : 'Vorschau vergrößern';

                    /*
                      * Teeinblue hinterlegt Breite und Höhe der Galerie als Inline-Werte.
                      * Nach dem mobilen Auf- oder Zuklappen müssen diese Werte deshalb
                      * nach dem Layoutwechsel erneut berechnet werden.
                      */
                    const refreshTeeinbluePreview = () => {
                        window.dispatchEvent(new Event('resize'));
                    };

                    window.requestAnimationFrame(() => {
                        refreshTeeinbluePreview();
                        window.requestAnimationFrame(refreshTeeinbluePreview);
                    });

                    window.setTimeout(refreshTeeinbluePreview, 240);
                },
                true
            );
        }

        if (this.sizeChartOpenButton) {
            this.sizeChartOpenButton.addEventListener('click', () => {
                this.openSizeChart();
            });
        }

        if (this.sizeChartCloseButton) {
            this.sizeChartCloseButton.addEventListener('click', () => {
                this.closeSizeChart();
            });
        }

        if (this.sizeChartDialog) {
            this.sizeChartDialog.addEventListener('click', (event) => {
                if (event.target === this.sizeChartDialog) {
                    this.closeSizeChart();
                }
            });

            this.sizeChartDialog.addEventListener('close', () => {
                document.documentElement.classList.remove('dp-b2b-modal-open');
            });
        }
    }

    setupMobileCartBar() {
        if (!this.mobileCartBar) {
            return;
        }

        if (typeof IntersectionObserver !== 'function') {
            this.mobileCartBar.classList.add('is-visible');
            return;
        }

        this.mobileCartObserver = new IntersectionObserver((entries) => {
            const isVisible = entries.some((entry) => {
                return entry.isIntersecting;
            });

            this.mobileCartBar.classList.toggle('is-visible', isVisible);
        }, {
            rootMargin: '0px 0px -8% 0px',
            threshold: 0
        });

        this.mobileCartObserver.observe(this.element);
    }

    setupMobileStepAccordion() {
        this.mobileSteps = Array.from(
            this.element.querySelectorAll('.dp-b2b__step')
        );

        if (this.mobileSteps.length === 0) {
            return;
        }

        this.mobileStepMedia = window.matchMedia('(max-width: 749px)');

        this.mobileSteps.forEach((step) => {
            const heading = step.querySelector('.dp-b2b__step-heading');

            if (!heading) {
                return;
            }

            heading.addEventListener('click', (event) => {
                if (
                    event.target.closest('button, a, input, select, textarea, label')
                ) {
                    return;
                }

                this.toggleMobileStep(step);
            });

            heading.addEventListener('keydown', (event) => {
                if (
                    event.target !== heading ||
                    (event.key !== 'Enter' && event.key !== ' ')
                ) {
                    return;
                }

                event.preventDefault();
                this.toggleMobileStep(step);
            });
        });

        const applyMobileMode = () => {
            const isMobile = this.mobileStepMedia.matches;

            this.mobileSteps.forEach((step, index) => {
                const heading = step.querySelector('.dp-b2b__step-heading');

                step.classList.toggle('is-mobile-accordion', isMobile);

                if (!heading) {
                    return;
                }

                if (!isMobile) {
                    step.classList.remove('is-mobile-collapsed');
                    heading.removeAttribute('role');
                    heading.removeAttribute('tabindex');
                    heading.removeAttribute('aria-expanded');
                    return;
                }

                heading.setAttribute('role', 'button');
                heading.setAttribute('tabindex', '0');

                if (step.dataset.mobileAccordionTouched !== 'true') {
                    this.setMobileStepExpanded(step, index === 0);
                } else {
                    heading.setAttribute(
                        'aria-expanded',
                        String(!step.classList.contains('is-mobile-collapsed'))
                    );
                }
            });
        };

        applyMobileMode();

        if (typeof this.mobileStepMedia.addEventListener === 'function') {
            this.mobileStepMedia.addEventListener('change', applyMobileMode);
        } else if (typeof this.mobileStepMedia.addListener === 'function') {
            this.mobileStepMedia.addListener(applyMobileMode);
        }
    }

    setMobileStepExpanded(step, isExpanded) {
        const heading = step.querySelector('.dp-b2b__step-heading');

        step.classList.toggle('is-mobile-collapsed', !isExpanded);

        if (heading) {
            heading.setAttribute('aria-expanded', String(isExpanded));
        }
    }

    toggleMobileStep(step) {
        if (!this.mobileStepMedia?.matches) {
            return;
        }

        const shouldExpand = step.classList.contains('is-mobile-collapsed');

        this.mobileSteps.forEach((candidate) => {
            candidate.dataset.mobileAccordionTouched = 'true';
            this.setMobileStepExpanded(
                candidate,
                candidate === step ? shouldExpand : false
            );
        });

        if (shouldExpand) {
            window.requestAnimationFrame(() => {
                step.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
        }
    }

    openSizeChart() {
        if (!this.sizeChartDialog) {
            return;
        }

        document.documentElement.classList.add('dp-b2b-modal-open');

        if (typeof this.sizeChartDialog.showModal === 'function') {
            this.sizeChartDialog.showModal();
            return;
        }

        this.sizeChartDialog.setAttribute('open', '');
    }

    closeSizeChart() {
        if (!this.sizeChartDialog) {
            return;
        }

        document.documentElement.classList.remove('dp-b2b-modal-open');

        if (typeof this.sizeChartDialog.close === 'function') {
            this.sizeChartDialog.close();
            return;
        }

        this.sizeChartDialog.removeAttribute('open');
    }

    toggleColor(button) {
        const colorHandle = button.dataset.colorHandle;
        const isSelected = button.classList.contains('is-selected');

        button.classList.toggle('is-selected', !isSelected);
        button.setAttribute('aria-pressed', String(!isSelected));

        const matchingGroup = this.sizeGroups.find((group) => {
            return group.dataset.colorHandle === colorHandle;
        });

        if (matchingGroup) {
            matchingGroup.classList.toggle('is-hidden', isSelected);

            if (isSelected) {
                matchingGroup.querySelectorAll('[data-quantity-input]').forEach((input) => {
                    input.value = 0;
                });
            }
        }

        if (!isSelected) {
            this.currentPreviewButton = button;
        } else if (this.currentPreviewButton === button) {
            this.currentPreviewButton =
                this.colorButtons.find((colorButton) => {
                    return colorButton.classList.contains('is-selected');
                }) ||
                this.colorButtons[0] ||
                null;
        }

        this.updateActivePreviewColor();
        this.updateAll();
    }

    setPreviewColorByHandle(colorHandle) {
        if (!colorHandle) {
            return;
        }

        const button = this.colorButtons.find((colorButton) => {
            return colorButton.dataset.colorHandle === colorHandle;
        });

        if (!button || this.currentPreviewButton === button) {
            return;
        }

        this.currentPreviewButton = button;
        this.updateActivePreviewColor();
    }

    normalizeConfiguredLabel(value) {
        return String(value || '')
            .replace(/\s+Sweatshirt$/i, '')
            .replace(/\s+Softshelljacke$/i, '')
            .trim();
    }

    getProductComposition(colorName) {
        const normalizedName = this.normalizeConfiguredLabel(colorName).toLowerCase();

        if (normalizedName === 'ash') {
            return `${this.productModel} · ${this.ashComposition}`;
        }

        if (
            normalizedName.includes('grey melange') ||
            normalizedName.includes('gray melange')
        ) {
            return `${this.productModel} · ${this.greyComposition}`;
        }

        return `${this.productModel} · ${this.defaultComposition}`;
    }

    getCurrentPreviewColor() {
        return {
            name: this.normalizeConfiguredLabel(
                this.currentPreviewButton?.dataset.colorName ||
                'Ausgewählte Farbe'
            ),
            value:
                this.currentPreviewButton?.dataset.colorValue ||
                '#ffffff',
            handle:
                this.currentPreviewButton?.dataset.colorHandle ||
                ''
        };
    }

    updateActivePreviewColor() {
        const color = this.getCurrentPreviewColor();

        this.setText(this.shirtPreviewName, color.name);
        this.setText(
            this.shirtPreviewProduct,
            this.getProductComposition(color.name)
        );

        if (this.teeinbluePreview) {
            this.teeinbluePreview.style.setProperty(
                '--dp-teeinblue-preview-color',
                color.value
            );
            this.teeinbluePreview.dataset.previewColor = color.value;
            this.teeinbluePreview.dataset.previewColorName = color.name;
        }

        this.scheduleTeeinblueSync(true);
    }

    sanitizeQuantity(input) {
        const parsedValue = Number.parseInt(input.value, 10);

        if (!Number.isFinite(parsedValue) || parsedValue < 0) {
            input.value = 0;
            return;
        }

        input.value = Math.floor(parsedValue);
    }

    isDoublePrintPosition(position = this.getSelectedPrintPosition()) {
        const normalized = this.normalizeText(position);

        const hasFront =
            normalized.includes('vorder') ||
            normalized.includes('front');

        const hasBack =
            normalized.includes('rück') ||
            normalized.includes('ruck') ||
            normalized.includes('back');

        return hasFront && hasBack;
    }

    isBackPrintPosition(position = this.getSelectedPrintPosition()) {
        const normalized = this.normalizeText(position);

        const hasFront =
            normalized.includes('vorder') ||
            normalized.includes('front');

        const hasBack =
            normalized.includes('rück') ||
            normalized.includes('ruck') ||
            normalized.includes('back');

        return hasBack && !hasFront;
    }

    getPreviewPrintPosition(useOrderPrintPosition = false) {
        const selectedPosition = this.getSelectedPrintPosition();

        if (
            useOrderPrintPosition ||
            !this.isDoublePrintPosition(selectedPosition)
        ) {
            return selectedPosition;
        }

        return this.previewSide === 'back'
            ? 'Rückseite'
            : 'Vorderseite';
    }

    updatePreviewSideControl() {
        const selectedPosition = this.getSelectedPrintPosition();
        const isDouble = this.isDoublePrintPosition(selectedPosition);

        if (this.previewSideControl) {
            this.previewSideControl.hidden = true;
            this.previewSideControl.setAttribute('aria-hidden', 'true');
        }

        this.previewSideButtons.forEach((button) => {
            const isActive =
                button.dataset.previewSide === this.previewSide;

            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
        });

        if (this.teeinbluePreview) {
            this.teeinbluePreview.dataset.previewSide =
                isDouble
                    ? this.previewSide
                    : this.isBackPrintPosition(selectedPosition)
                        ? 'back'
                        : 'front';

            this.teeinbluePreview.dataset.printViewMode =
                isDouble
                    ? 'both'
                    : this.isBackPrintPosition(selectedPosition)
                        ? 'back'
                        : 'front';
        }

        this.updateUploadSideStatus();
    }

    updateUploadSideStatus() {
        const isDouble = this.isDoublePrintPosition(
            this.getSelectedPrintPosition()
        );
        const useEmail = Boolean(this.printEmailCheckbox?.checked);
        const showControl = isDouble && !useEmail;

        if (this.uploadSideControl) {
            this.uploadSideControl.hidden = !showControl;
            this.uploadSideControl.setAttribute(
                'aria-hidden',
                String(!showControl)
            );
        }

        this.uploadSideButtons.forEach((button) => {
            const side = button.dataset.previewSide;
            const isComplete =
                side === 'front' || side === 'back'
                    ? this.artworkCompletionBySide[side] === true
                    : false;

            button.classList.toggle('is-complete', isComplete);
            button.setAttribute(
                'aria-label',
                `${side === 'back' ? 'Rückseite' : this.frontPrintLabel}: ${
                    isComplete ? 'Motiv hochgeladen' : 'noch offen'
                }`
            );
        });

        this.uploadSideStatuses.forEach((status) => {
            const side = status.dataset.uploadSideStatus;
            const isComplete =
                side === 'front' || side === 'back'
                    ? this.artworkCompletionBySide[side] === true
                    : false;

            status.textContent = isComplete
                ? 'Fertig'
                : 'Offen';
        });

        if (this.uploadActiveSide) {
            const sideLabel = this.previewSide === 'back'
                ? 'Rückseite'
                : this.frontPrintLabel;

            this.uploadActiveSide.innerHTML =
                `Sie bearbeiten gerade: <strong>${sideLabel}</strong>`;
        }

        if (this.uploadNextSideButton) {
            const showNext =
                showControl &&
                this.previewSide === 'front' &&
                this.artworkCompletionBySide.front === true &&
                this.artworkCompletionBySide.back !== true;

            this.uploadNextSideButton.hidden = !showNext;
            this.uploadNextSideButton.setAttribute(
                'aria-hidden',
                String(!showNext)
            );
        }
    }

    getRequiredArtworkSides() {
        const position = this.getSelectedPrintPosition().toLowerCase();

        if (position.includes('vorder') && position.includes('rück')) {
            return ['front', 'back'];
        }

        if (position.includes('rück') && !position.includes('vorder')) {
            return ['back'];
        }

        return ['front'];
    }

    updateUploadContext() {
        const requiredSides = this.getRequiredArtworkSides();

        if (requiredSides.length === 2) {
            const activeSide =
                this.previewSide === 'back'
                    ? 'Rückseite'
                    : this.frontPrintLabel;

            this.setText(
                this.uploadContextTitle,
                `Motiv: ${activeSide}`
            );

            this.setText(
                this.uploadContextText,
                `Laden Sie jetzt das Motiv für ${activeSide === 'Rückseite' ? 'die Rückseite' : activeSide === 'Vorderseite' ? 'die Vorderseite' : 'die Herzseite der Brust'} hoch. Anschließend wählen Sie oben die andere Druckseite aus.`
            );
            return;
        }

        if (requiredSides[0] === 'back') {
            this.setText(this.uploadContextTitle, 'Datei für Rückseite');
            this.setText(
                this.uploadContextText,
                'Laden Sie das Motiv für die Rückseite hoch und richten Sie es innerhalb der maximalen Druckfläche aus.'
            );
            return;
        }

        this.setText(this.uploadContextTitle, `Datei: ${this.frontPrintLabel}`);
        this.setText(
            this.uploadContextText,
            this.frontPrintLabel === 'Vorderseite'
                ? 'Laden Sie das Motiv für die Vorderseite hoch und richten Sie es innerhalb der maximalen Druckfläche aus.'
                : 'Laden Sie das Motiv für die Herzseite der Brust hoch und richten Sie es innerhalb der maximalen Druckfläche aus.'
        );
    }

    updateArtworkVisibility() {
        const useEmail = Boolean(this.printEmailCheckbox?.checked);

        this.artworkMethodButtons.forEach((button) => {
            const isActive =
                (button.dataset.artworkMethod === 'email') === useEmail;

            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
        });

        if (this.artworkEmailHelp) {
            this.artworkEmailHelp.hidden = !useEmail;
        }

        if (this.teeinblueUploadArea) {
            this.teeinblueUploadArea.hidden = useEmail;
            this.teeinblueUploadArea.setAttribute('aria-hidden', String(useEmail));
        }

        if (this.summaryArtwork) {
            this.summaryArtwork.hidden = useEmail;
        }

        if (this.summaryEmail) {
            this.summaryEmail.hidden = !useEmail;
        }

        this.updateUploadSideStatus();
    }

    getTeeinblueArtworkRoot() {
        return (
            this.teeinblueFormContainer?.querySelector('#tee-artwork-form') ||
            document.querySelector('#tee-artwork-form') ||
            null
        );
    }

    getTeeinblueNativeForm() {
        return this.getTeeinblueArtworkRoot()?.closest('form') || null;
    }

    getTeeinblueAtcButton() {
        const root = this.getTeeinblueArtworkRoot();
        const form = root?.closest('form');

        return (
            form?.querySelector('#teeAtcButton') ||
            root?.querySelector('#teeAtcButton') ||
            document.querySelector('#teeAtcButton') ||
            null
        );
    }

    getTeeinblueQuantityInputs() {
        const form = this.getTeeinblueNativeForm();

        if (!form) {
            return [];
        }

        return Array.from(
            new Set(
                form.querySelectorAll(
                    '.tee-form-actions .tee-quantity-input, .tee-form-actions input[name="quantity"], input[name="quantity"]'
                )
            )
        );
    }

    isTeeinblueLoaded() {
        return Boolean(this.getTeeinblueArtworkRoot());
    }

    getTeeinblueUploadFields() {
        const root = this.getTeeinblueArtworkRoot();

        if (!root) {
            return [];
        }

        const uploadMarkers = Array.from(
            root.querySelectorAll(
                '.tee-photo-uploaded, .tee-photo-image, .tee-photo-clear'
            )
        );

        return Array.from(
            new Set(
                uploadMarkers.map((marker) => {
                    return marker.closest('.tee-field') || marker.parentElement;
                }).filter(Boolean)
            )
        );
    }

    hasTeeinblueUploadForSide(side = this.getCurrentArtworkSide()) {
        const uploadFields = this.getTeeinblueUploadFields();

        if (uploadFields.length === 0) {
            return false;
        }

        const getFieldSide = (field) => {
            const label = this.normalizeText(
                [
                    field.getAttribute?.('data-side'),
                    field.getAttribute?.('data-view'),
                    field.querySelector?.('.tee-field__heading')?.textContent,
                    field.textContent
                ].filter(Boolean).join(' ')
            );

            const isFront =
                label.includes('vorderseite') ||
                label.includes('front');
            const isBack =
                label.includes('rückseite') ||
                label.includes('ruckseite') ||
                label.includes('back');

            if (isFront && !isBack) {
                return 'front';
            }

            if (isBack && !isFront) {
                return 'back';
            }

            return '';
        };

        const labeledFields = uploadFields
            .map((field) => ({ field, side: getFieldSide(field) }))
            .filter((entry) => Boolean(entry.side));

        if (labeledFields.length > 0) {
            return labeledFields.some((entry) => entry.side === side);
        }

        /*
            Bei den Einseiten-Varianten rendert Teeinblue nur das aktuell
            bearbeitete Upload-Feld. Dieses Feld hat nicht immer eine auslesbare
            Vorder-/Rückseiten-Beschriftung. In diesem Fall gehört der sichtbare
            Upload zur aktuell ausgewählten Vorschauseite.
        */
        return uploadFields.length > 0;
    }

    isTeeinblueNativeButtonEnabled(button = this.getTeeinblueAtcButton()) {
        if (!button) {
            return false;
        }

        return !(
            button.disabled ||
            button.getAttribute('disabled') !== null ||
            button.getAttribute('aria-disabled') === 'true' ||
            button.classList.contains('loading') ||
            button.classList.contains('is-loading') ||
            button.classList.contains('tee-processing')
        );
    }

    isTeeinblueComplete() {
        const button = this.getTeeinblueAtcButton();

        if (button) {
            return this.isTeeinblueNativeButtonEnabled(button);
        }

        /*
            In der eingebetteten Teeinblue-Ansicht gibt es bewusst keinen nativen
            #teeAtcButton. Ein erfolgreich hochgeladenes Bild ist dort an der von
            Teeinblue erzeugten Upload-Vorschau bzw. dem Lösch-Button erkennbar.
        */
        return this.hasTeeinblueUploadForSide();
    }

    getCurrentArtworkSide() {
        const requiredSides = this.getRequiredArtworkSides();

        if (requiredSides.length === 1) {
            return requiredSides[0];
        }

        return this.previewSide === 'back'
            ? 'back'
            : 'front';
    }

    captureArtworkCompletion() {
        if (
            this.printEmailCheckbox?.checked ||
            !this.isTeeinblueLoaded()
        ) {
            return false;
        }

        const side = this.getCurrentArtworkSide();

        if (side !== 'front' && side !== 'back') {
            return false;
        }

        const button = this.getTeeinblueAtcButton();
        const sideIsComplete = button
            ? this.isTeeinblueNativeButtonEnabled(button)
            : this.hasTeeinblueUploadForSide(side);

        if (!sideIsComplete) {
            return false;
        }

        this.artworkCompletionBySide[side] = true;

        window.__dpB2BArtworkCompletion = {
            ...this.artworkCompletionBySide
        };

        return true;
    }

    getMissingArtworkSides() {
        return this.getRequiredArtworkSides().filter((side) => {
            return this.artworkCompletionBySide[side] !== true;
        });
    }

    hasArtworkMethod() {
        if (this.printEmailCheckbox?.checked) {
            return true;
        }

        this.captureArtworkCompletion();

        const requiredSides = this.getRequiredArtworkSides();

        if (requiredSides.length === 2) {
            return requiredSides.every((side) => {
                return this.artworkCompletionBySide[side] === true;
            });
        }

        return this.isTeeinblueComplete();
    }

    getArtworkMethod() {
        return this.printEmailCheckbox?.checked
            ? 'Druckdaten folgen per E-Mail'
            : 'Druckdaten über Motivgestaltung';
    }

    getBackgroundTreatment() {
        const selectedInput = this.backgroundTreatmentInputs.find((input) => {
            return input.checked;
        });

        return selectedInput?.value || 'Professionelle Prüfung durch DesignPrinz';
    }

    updateArtworkStatus() {
        const useEmail = Boolean(this.printEmailCheckbox?.checked);
        const requiredSides = this.getRequiredArtworkSides();

        this.updateArtworkVisibility();

        if (useEmail) {
            this.setArtworkMessage(
                requiredSides.length === 2
                    ? 'Die Dateien für Vorder- und Rückseite werden nach der Bestellung per E-Mail übermittelt.'
                    : 'Die Druckdatei wird nach der Bestellung per E-Mail übermittelt.',
                'success'
            );

            this.setText(
                this.summaryTeeinblueStatus,
                'Für diese Bestellung nicht erforderlich.'
            );
            return;
        }

        if (!this.isTeeinblueLoaded()) {
            this.setArtworkMessage(
                'Der Gestaltungsbereich wird geladen. Bitte warten Sie einen Moment.',
                ''
            );
            this.setText(
                this.summaryTeeinblueStatus,
                'Editor wird geladen …'
            );
            return;
        }

        this.captureArtworkCompletion();
        this.updateUploadSideStatus();

        if (this.hasArtworkMethod()) {
            this.setArtworkMessage(
                requiredSides.length === 2
                    ? 'Die Motivgestaltung für Vorder- und Rückseite ist vollständig.'
                    : 'Die Motivgestaltung ist vollständig.',
                'success'
            );

            this.setText(
                this.summaryTeeinblueStatus,
                'Konfiguration vollständig und für den Warenkorb bereit.'
            );
            return;
        }

        if (requiredSides.length === 2) {
            const missingSides = this.getMissingArtworkSides();
            const missingLabels = missingSides.map((side) => {
                return side === 'back'
                    ? 'Rückseite'
                    : this.frontPrintLabel;
            });

            const missingText =
                missingLabels.length === 2
                    ? this.frontPrintLabel === 'Vorderseite'
                        ? 'Vorder- und Rückseite'
                        : 'Brust Herzseite und Rückseite'
                    : missingLabels[0] || 'die zweite Druckseite';

            this.setArtworkMessage(
                `Bitte vervollständigen Sie noch die Gestaltung für ${missingText}.`,
                ''
            );

            this.setText(
                this.summaryTeeinblueStatus,
                `Noch offen: ${missingText}.`
            );
            return;
        }

        this.setArtworkMessage(
            'Bitte laden Sie das Motiv hoch und bestätigen Sie die Gestaltung.',
            ''
        );

        this.setText(
            this.summaryTeeinblueStatus,
            'Noch nicht vollständig bestätigt.'
        );
    }

    setArtworkMessage(message, type = '') {
        if (!this.artworkMessage) {
            return;
        }

        const nextMessage = String(message);
        const shouldBeError = type === 'error';
        const shouldBeSuccess = type === 'success';

        if (this.artworkMessage.textContent !== nextMessage) {
            this.artworkMessage.textContent = nextMessage;
        }

        if (
            this.artworkMessage.classList.contains('is-error') !== shouldBeError
        ) {
            this.artworkMessage.classList.toggle('is-error', shouldBeError);
        }

        if (
            this.artworkMessage.classList.contains('is-success') !== shouldBeSuccess
        ) {
            this.artworkMessage.classList.toggle('is-success', shouldBeSuccess);
        }
    }

    observeTeeinblue() {
        if (this.teeinblueObserver) {
            return;
        }

        const teeinblueSelector = [
            '#tee-artwork-form',
            '#teeAtcButton',
            '#teeinblue-form',
            '#teeinblue-gallery',
            '[class*="tee-"]',
            '[id^="tee-"]'
        ].join(', ');

        const isTeeinblueNode = (node) => {
            if (!(node instanceof Element)) {
                return false;
            }

            return Boolean(
                node.matches(teeinblueSelector) ||
                node.closest(teeinblueSelector) ||
                node.querySelector(teeinblueSelector)
            );
        };

        const refresh = (mutations = [], forceSync = false) => {
            const touchesTeeinblue =
                mutations.length === 0 ||
                mutations.some((mutation) => {
                    if (isTeeinblueNode(mutation.target)) {
                        return true;
                    }

                    return Array.from(mutation.addedNodes).some(isTeeinblueNode);
                });

            if (!touchesTeeinblue) {
                return;
            }

            window.clearTimeout(this.teeinblueStateTimer);
            this.teeinblueStateTimer = window.setTimeout(() => {
                const currentRoot = this.getTeeinblueArtworkRoot();
                const rootChanged = Boolean(
                    currentRoot && currentRoot !== this.lastTeeinblueRoot
                );

                this.lastTeeinblueRoot = currentRoot;
                this.installTeeinblueHooks();
                this.updateTeeinblueLoadingState();
                this.syncPersonalizationSideVisibility();
                this.syncGallerySide();

                if (rootChanged || forceSync) {
                    this.scheduleTeeinblueSync(true);
                }

                this.updateArtworkStatus();
                this.updateCartButton(
                    this.getTotalQuantity(),
                    this.getSelectedPrintPosition(),
                    this.getTier(this.getTotalQuantity())
                );
            }, 120);
        };

        this.teeinblueObserver = new MutationObserver((mutations) => {
            refresh(mutations, false);
        });
        this.teeinblueObserver.observe(document.documentElement, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'disabled',
                'aria-disabled',
                'class',
                'hidden',
                'data-state',
                'data-status'
            ]
        });

        const refreshFromTeeinblueEvent = (event) => {
            if (!event.target?.closest?.('#tee-artwork-form')) {
                return;
            }

            window.setTimeout(() => {
                refresh([], false);
            }, 0);
        };

        document.addEventListener(
            'input',
            refreshFromTeeinblueEvent,
            true
        );
        document.addEventListener(
            'change',
            refreshFromTeeinblueEvent,
            true
        );
        document.addEventListener(
            'click',
            refreshFromTeeinblueEvent,
            true
        );

        document.addEventListener('teeinblue:rendered', () => {
            refresh([], true);
        });
        document.addEventListener('teeinblue:updated', () => {
            refresh([], true);
        });

        refresh([], true);
    }

    updateTeeinblueLoadingState() {
        if (this.teeinblueGalleryLoading && this.teeinblueGallery) {
            const hasGalleryContent = Array.from(this.teeinblueGallery.children).some(
                (child) => !child.hasAttribute('data-teeinblue-gallery-loading')
            );
            this.teeinblueGalleryLoading.hidden = hasGalleryContent;
        }

        if (this.teeinblueFormLoading && this.teeinblueFormContainer) {
            const hasFormContent = Boolean(this.getTeeinblueArtworkRoot());
            this.teeinblueFormLoading.hidden = hasFormContent;
        }
    }

    installTeeinblueHooks() {
        const api = window.teeinblue;

        if (!api || typeof api !== 'object') {
            return false;
        }

        if (!window.__dpB2BTeeinblueBridge) {
            window.__dpB2BTeeinblueBridge = {
                active: null
            };
        }

        const currentTransform = api.transformBeforeAddToCart;

        if (currentTransform?.__dpB2BWrapper === true) {
            return true;
        }

        const originalTransform =
            typeof currentTransform === 'function'
                ? currentTransform
                : null;

        const wrappedTransform = async function (input) {
            let output = input;

            if (originalTransform) {
                const originalResult = await originalTransform(input);
                output = originalResult || input;
            }

            const active = window.__dpB2BTeeinblueBridge?.active;

            if (active && typeof active.transform === 'function') {
                output = active.transform(output) || output;
            }

            return output;
        };

        wrappedTransform.__dpB2BWrapper = true;
        api.transformBeforeAddToCart = wrappedTransform;

        return true;
    }

    scheduleTeeinblueSync(forceColorRefresh = false) {
        if (this.isPreparingCartVariant) {
            return;
        }

        window.clearTimeout(this.teeinblueSyncTimer);
        this.teeinblueSyncTimer = window.setTimeout(() => {
            this.syncTeeinblueVariant(forceColorRefresh).catch((error) => {
                console.warn('Die Shopify-Variante konnte noch nicht mit der Motivvorschau synchronisiert werden.', error);
            });
        }, 80);
    }

    getPreviewTier(totalQuantity) {
        return this.getTier(totalQuantity) || this.getTier(this.startOfferQuantity) || '10–24';
    }

    synchronizeVariantBridge(variant, color) {
        if (!variant) {
            return;
        }

        const variantId = String(variant.id);

        if (this.teeinblueVariantSelect) {
            let option = this.teeinblueVariantSelect.options[0] || null;

            if (!option) {
                option = document.createElement('option');
                this.teeinblueVariantSelect.appendChild(option);
            }

            option.value = variantId;
            option.textContent = variant.title || variantId;
            option.selected = true;
            option.setAttribute('selected', 'selected');

            this.teeinblueVariantSelect.value = variantId;
            this.dispatchControlChange(this.teeinblueVariantSelect);
        }

        if (this.variantBridgeQuantity) {
            this.variantBridgeQuantity.value = String(
                Math.max(this.getTotalQuantity(), 1)
            );
        }

        if (this.variantBridgeForm) {
            this.variantBridgeForm.dataset.selectedVariantId = variantId;
            this.variantBridgeForm.dispatchEvent(
                new Event('input', { bubbles: true })
            );
            this.variantBridgeForm.dispatchEvent(
                new Event('change', { bubbles: true })
            );
        }

        this.applyTeeinblueVariantColor(variant, color.value);

        const url = new URL(window.location.href);
        if (url.searchParams.get('variant') !== variantId) {
            url.searchParams.delete('option_values');
            url.searchParams.set('variant', variantId);
            window.history.replaceState(
                { ...(window.history.state || {}), variantId },
                '',
                `${url.pathname}${url.search}${url.hash}`
            );
        }

        const detail = {
            variant,
            selectedVariant: variant,
            productVariant: variant,
            data: { variant },
            colorHex: color.value,
            colorName: color.name
        };

        const targets = [
            this.variantBridgeForm,
            this.element,
            document,
            document.body,
            window
        ].filter(Boolean);

        const eventNames = [
            'variant:change',
            'variant-change',
            'product:variant-change',
            'product-variant-change',
            'teeinblue:variant-change',
            'dp:b2b-personalization-change'
        ];

        targets.forEach((target) => {
            eventNames.forEach((eventName) => {
                target.dispatchEvent(
                    new CustomEvent(eventName, {
                        bubbles: true,
                        detail
                    })
                );
            });
        });
    }

    getSideSpecificFieldContainer(input) {
        if (!input) {
            return null;
        }

        const candidates = [];
        let node = input.parentElement;
        let depth = 0;

        while (node && node !== this.getTeeinblueArtworkRoot() && depth < 8) {
            candidates.push(node);
            node = node.parentElement;
            depth += 1;
        }

        return candidates.find((candidate) => {
            const text = this.normalizeText(candidate.textContent);
            const hasFront = text.includes('vorderseite') || text.includes('front');
            const hasBack = text.includes('rückseite') || text.includes('ruckseite') || text.includes('back');
            return hasFront !== hasBack;
        }) || candidates[0] || null;
    }

    syncPersonalizationSideVisibility() {
        /*
            Die Sichtbarkeit der Artwork-Felder wird ausschließlich durch die
            Varianten-Verknüpfung in der Shopify-Produkt-Campaign gesteuert.

            Eine zusätzliche Ausblendung im DesignPrinz-Code kann bei
            Einzelvarianten den falschen Elterncontainer deaktivieren.
        */
        const root = this.getTeeinblueArtworkRoot();

        if (!root) {
            return;
        }

        root
            .querySelectorAll('.dp-b2b__personalization-side-hidden')
            .forEach((container) => {
                container.hidden = false;
                container.removeAttribute('aria-hidden');
                container.classList.remove(
                    'dp-b2b__personalization-side-hidden'
                );

                container
                    .querySelectorAll(
                        '[data-dp-original-disabled]'
                    )
                    .forEach((control) => {
                        control.disabled =
                            control.getAttribute(
                                'data-dp-original-disabled'
                            ) === 'true';

                        control.removeAttribute(
                            'data-dp-original-disabled'
                        );
                    });
            });
    }

    getPrintPositionViewMode() {
        const position = this.normalizeText(
            this.getSelectedPrintPosition()
        );

        const hasFront =
            position.includes('vorder') ||
            position.includes('front');

        const hasBack =
            position.includes('rück') ||
            position.includes('ruck') ||
            position.includes('back');

        if (hasFront && hasBack) {
            return 'both';
        }

        if (hasBack) {
            return 'back';
        }

        return 'front';
    }

    getGalleryControlLabel(element) {
        if (!element) {
            return '';
        }

        const image = element.matches?.('img')
            ? element
            : element.querySelector?.('img');

        const values = [
            element.getAttribute?.('aria-label'),
            element.getAttribute?.('title'),
            element.getAttribute?.('data-title'),
            element.getAttribute?.('data-label'),
            element.getAttribute?.('data-view'),
            element.getAttribute?.('data-side'),
            element.textContent,
            image?.getAttribute('alt'),
            image?.getAttribute('title'),
            image?.currentSrc,
            image?.src
        ];

        return this.normalizeText(
            values.filter(Boolean).join(' ')
        );
    }

    getNativeGalleryControls() {
        if (!this.teeinblueGallery) {
            return [];
        }

        const selector = [
            '[role="tab"]',
            '[data-thumbnail]',
            '[data-thumb]',
            '[data-slide-to]',
            '[class*="thumbnail" i]',
            '[class*="thumb" i] button',
            'button[class*="thumb" i]',
            '[class*="thumbnail" i] button'
        ].join(', ');

        const candidates = Array.from(
            this.teeinblueGallery.querySelectorAll(selector)
        ).filter((element) => {
            if (element.closest('[data-gallery-view-switch]')) {
                return false;
            }

            const label = this.getGalleryControlLabel(element);

            if (
                label.includes('previous') ||
                label.includes('zurück') ||
                label.includes('zuruck') ||
                label.includes('next') ||
                label.includes('weiter') ||
                label.includes('zoom') ||
                label.includes('close') ||
                label.includes('schließen') ||
                label.includes('schliessen')
            ) {
                return false;
            }

            return true;
        });

        const controls = [];

        candidates.forEach((candidate) => {
            const clickable = candidate.matches(
                'button, [role="tab"], [role="button"], a, input'
            )
                ? candidate
                : candidate.querySelector(
                        'button, [role="tab"], [role="button"], a, input'
                    ) || candidate;

            if (
                controls.some((control) => {
                    return control === clickable || control.contains(clickable);
                })
            ) {
                return;
            }

            controls.push(clickable);
        });

        return controls;
    }

    getNativeGalleryItem(control) {
        if (!control) {
            return null;
        }

        return (
            control.closest(
                '[class*="thumbnail" i], [class*="thumb-item" i], [class*="thumb_slide" i], [role="tab"]'
            ) ||
            control
        );
    }

    markNativeGalleryStrip(controls) {
        if (!this.teeinblueGallery || controls.length === 0) {
            return;
        }

        const items = Array.from(
            new Set(
                controls
                    .map((control) => this.getNativeGalleryItem(control))
                    .filter(Boolean)
            )
        );

        items.forEach((item) => {
            item.classList.add('dp-b2b__native-view-item');
            item.setAttribute('aria-hidden', 'true');
        });

        let container = items[0]?.parentElement || null;

        while (
            container &&
            container !== this.teeinblueGallery &&
            !items.every((item) => container.contains(item))
        ) {
            container = container.parentElement;
        }

        if (
            container &&
            container !== this.teeinblueGallery
        ) {
            const containsMainCanvas = Boolean(
                container.querySelector(
                    'canvas:not([class*="thumb" i]), video:not([class*="thumb" i])'
                )
            );

            if (
                !containsMainCanvas &&
                /thumb|thumbnail|navigation|pagination|carousel/i.test(
                    String(container.className || '')
                )
            ) {
                container.classList.add('dp-b2b__native-view-strip');
                container.setAttribute('aria-hidden', 'true');
            }
        }
    }

    getMappedGalleryControls() {
        const controls = this.getNativeGalleryControls();

        if (controls.length === 0) {
            return {
                controls,
                front: null,
                back: null
            };
        }

        let front = controls.find((control) => {
            const label = this.getGalleryControlLabel(control);
            return (
                label.includes('vorder') ||
                label.includes('front')
            );
        }) || null;

        let back = controls.find((control) => {
            const label = this.getGalleryControlLabel(control);
            return (
                label.includes('rück') ||
                label.includes('ruck') ||
                label.includes('back')
            );
        }) || null;

        /*
            Wichtig:
            Keine Fallback-Zuordnung über erstes/letztes Element.
            In der nativen Galerie können dort auch Farbmotive oder weitere
            Varianten-Mockups liegen. Das hatte den automatischen Farbdurchlauf
            ausgelöst.
        */

        controls.forEach((control) => {
            const view =
                control === front
                    ? 'front'
                    : control === back
                        ? 'back'
                        : '';

            if (view) {
                control.dataset.dpGalleryView = view;
            }
        });

        return {
            controls,
            front,
            back
        };
    }

    hideNativeGalleryNavigation() {
        if (!this.teeinblueGallery) {
            return;
        }

        const galleryRect =
            this.teeinblueGallery.getBoundingClientRect();

        const controls = Array.from(
            this.teeinblueGallery.querySelectorAll(
                'button, [role="button"], a'
            )
        );

        controls.forEach((control) => {
            const rect = control.getBoundingClientRect();

            if (
                rect.width < 2 ||
                rect.height < 2 ||
                rect.width > 110 ||
                rect.height > 140
            ) {
                return;
            }

            const label = this.getGalleryControlLabel(control);
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;
            const relativeX =
                galleryRect.width > 0
                    ? (centerX - galleryRect.left) / galleryRect.width
                    : 0.5;

            const relativeY =
                galleryRect.height > 0
                    ? (centerY - galleryRect.top) / galleryRect.height
                    : 0.5;

            const labelledNavigation =
                label.includes('previous') ||
                label.includes('prev') ||
                label.includes('next') ||
                label.includes('weiter') ||
                label.includes('zurück') ||
                label.includes('zuruck');

            const edgeNavigation =
                relativeY >= 0.18 &&
                relativeY <= 0.82 &&
                (relativeX <= 0.18 || relativeX >= 0.82);

            if (labelledNavigation || edgeNavigation) {
                control.classList.add(
                    'dp-b2b__gallery-navigation-hidden'
                );
                control.setAttribute('aria-hidden', 'true');
                control.tabIndex = -1;
            }
        });

        const nativeControls = this.getNativeGalleryControls();
        this.markNativeGalleryStrip(nativeControls);
    }

    syncGallerySide() {
        this.updatePreviewSideControl();
        this.hideNativeGalleryNavigation();
    }

    forceNativeTeeinblueVariant(variant) {
        if (!variant?.id) {
            return false;
        }

        const form = this.getTeeinblueNativeForm();

        if (!form) {
            return false;
        }

        const variantId = String(variant.id);
        const controls = Array.from(
            form.querySelectorAll(
                'select[name="id"], input[name="id"], [data-product-variant-select]'
            )
        );

        let changed = false;

        controls.forEach((control) => {
            if (control === this.teeinblueVariantSelect) {
                return;
            }

            if (control instanceof HTMLSelectElement) {
                let option = Array.from(control.options).find(
                    (item) => String(item.value) === variantId
                );

                if (!option) {
                    option = document.createElement('option');
                    option.value = variantId;
                    option.textContent = variant.title || variantId;
                    control.appendChild(option);
                }

                const setter = Object.getOwnPropertyDescriptor(
                    HTMLSelectElement.prototype,
                    'value'
                )?.set;

                if (setter) {
                    setter.call(control, variantId);
                } else {
                    control.value = variantId;
                }

                option.selected = true;
                this.dispatchControlChange(control);
                changed = true;
                return;
            }

            if (
                control instanceof HTMLInputElement &&
                ['hidden', 'radio'].includes(control.type)
            ) {
                const setter = Object.getOwnPropertyDescriptor(
                    HTMLInputElement.prototype,
                    'value'
                )?.set;

                if (setter) {
                    setter.call(control, variantId);
                } else {
                    control.value = variantId;
                }

                if (control.type === 'radio') {
                    control.checked = true;
                }

                this.dispatchControlChange(control);
                changed = true;
            }
        });

        form.dataset.selectedVariantId = variantId;

        const detail = {
            variant,
            selectedVariant: variant,
            productVariant: variant,
            data: { variant }
        };

        [
            'variant:change',
            'variant-change',
            'product:variant-change',
            'product-variant-change',
            'teeinblue:variant-change'
        ].forEach((eventName) => {
            form.dispatchEvent(
                new CustomEvent(eventName, {
                    bubbles: true,
                    detail
                })
            );
        });

        return changed;
    }

    getOptionValueId(position, targetValue) {
        const option = Array.from(this.optionMap?.options || []).find((item) => {
            return Number(item.position) === Number(position);
        });

        if (!option) {
            return '';
        }

        const normalizedTarget = this.normalizeText(targetValue);
        const value = Array.from(option.values || []).find((item) => {
            return this.normalizeText(item.name) === normalizedTarget;
        });

        return value?.id ? String(value.id) : '';
    }

    getVariantResolutionKey(printPosition, tier, colorName) {
        return [printPosition, tier, colorName]
            .map((value) => this.normalizeText(value))
            .join('|');
    }

    async resolveVariant(printPosition, tier, colorName) {
        if (!printPosition || !tier || !colorName || !this.sectionId) {
            return null;
        }

        const key = this.getVariantResolutionKey(
            printPosition,
            tier,
            colorName
        );

        if (this.variantResolutionCache.has(key)) {
            return this.variantResolutionCache.get(key);
        }

        const optionValueIds = [
            this.getOptionValueId(1, printPosition),
            this.getOptionValueId(2, tier),
            this.getOptionValueId(3, colorName)
        ];

        if (optionValueIds.some((id) => !id)) {
            throw new Error(
                `Optionswerte konnten nicht zugeordnet werden: ${printPosition} / ${tier} / ${colorName}`
            );
        }

        const request = (async () => {
            const url = new URL(this.productUrl, window.location.origin);
            url.searchParams.set('section_id', this.sectionId);
            url.searchParams.set('option_values', optionValueIds.join(','));

            const response = await fetch(url.toString(), {
                headers: {
                    Accept: 'text/html',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                throw new Error(
                    `Shopify-Variante konnte nicht geladen werden (${response.status}).`
                );
            }

            const htmlText = await response.text();
            const html = new DOMParser().parseFromString(htmlText, 'text/html');
            const script = html.querySelector('[data-resolved-variant]');

            if (!script) {
                throw new Error(
                    'Die Antwort enthält keine aufgelöste Shopify-Variante.'
                );
            }

            const variant = JSON.parse(script.textContent);

            if (!variant?.id) {
                throw new Error(
                    `Für ${printPosition} / ${tier} / ${colorName} existiert keine Variante.`
                );
            }

            return variant;
        })();

        this.variantResolutionCache.set(key, request);

        try {
            const variant = await request;
            this.variantResolutionCache.set(key, variant);
            return variant;
        } catch (error) {
            this.variantResolutionCache.delete(key);
            throw error;
        }
    }

    async syncTeeinblueVariant(
        forceColorRefresh = false,
        useOrderPrintPosition = false
    ) {
        const orderPrintPosition = this.getSelectedPrintPosition();
        const printPosition = this.getPreviewPrintPosition(
            useOrderPrintPosition
        );
        const tier = this.getPreviewTier(this.getTotalQuantity());
        const color = this.getCurrentPreviewColor();
        const variant = await this.resolveVariant(
            printPosition,
            tier,
            color.name
        );

        if (!variant) {
            return;
        }

        this.currentPreviewVariant = variant;
        this.currentResolvedVariant = variant;

        if (useOrderPrintPosition) {
            this.currentMainVariant = variant;
        }

        const resolvedVariantId = String(variant.id);

        if (this.lastGalleryVariantId !== resolvedVariantId) {
            this.lastGalleryVariantId = resolvedVariantId;
        }

        const syncKey = [
            variant.id,
            color.value,
            printPosition,
            useOrderPrintPosition ? 'order' : 'preview'
        ].join('|');

        if (
            !forceColorRefresh &&
            this.lastTeeinblueSyncKey === syncKey &&
            this.isTeeinblueLoaded()
        ) {
            return;
        }

        this.lastTeeinblueSyncKey = syncKey;
        this.synchronizeVariantBridge(variant, color);

        const root = this.getTeeinblueArtworkRoot();

        if (root) {
            const printPositionChanged = await this.applyTeeinblueOptionValue(
                root,
                printPosition
            );
            await this.wait(220);

            const tierRoot = this.getTeeinblueArtworkRoot() || root;
            const tierChanged = await this.applyTeeinblueOptionValue(
                tierRoot,
                tier
            );
            await this.wait(220);

            const colorRoot = this.getTeeinblueArtworkRoot() || tierRoot;
            const colorChanged = await this.applyTeeinblueOptionValue(
                colorRoot,
                color.name
            );
            await this.wait(320);

            this.forceNativeTeeinblueVariant(variant);
            this.synchronizeVariantBridge(variant, color);
            await this.wait(180);

            window.__dpB2BLastVariantSync = {
                variantId: String(variant.id),
                printPosition,
                tier,
                color: color.name,
                nativeControls: {
                    printPosition: printPositionChanged,
                    tier: tierChanged,
                    color: colorChanged
                }
            };

            this.setTeeinblueQuantity(Math.max(this.getTotalQuantity(), 1));
            this.applyTeeinblueVariantColor(variant, color.value);
            this.syncPersonalizationSideVisibility();
            this.syncGallerySide();
        }

        window.setTimeout(() => {
            this.forceNativeTeeinblueVariant(variant);
            this.synchronizeVariantBridge(variant, color);
            this.syncPersonalizationSideVisibility();
            this.syncGallerySide();
            this.updateTeeinblueLoadingState();
        }, 500);

        const detail = {
            variant,
            colorHex: color.value,
            colorName: color.name,
            printPosition,
            orderPrintPosition,
            previewSide: this.previewSide
        };

        document.dispatchEvent(
            new CustomEvent('dp:b2b-teeinblue-change', { detail })
        );
        document.dispatchEvent(
            new CustomEvent('teeinblue:variant-change', { detail })
        );
        document.dispatchEvent(
            new CustomEvent('variant:change', { detail: { variant } })
        );
    }

    applyTeeinblueVariantColor(variant, colorHex) {
        if (window.teeinblue && typeof window.teeinblue === 'object') {
            window.teeinblue.variant = {
                ...(window.teeinblue.variant || {}),
                id: String(variant.id),
                color_hex: colorHex
            };
        }

        const campaignVariant =
            window.teeinblueCampaign?.variantsById?.[variant.id] ||
            window.teeinblueCampaign?.variantsById?.[String(variant.id)] ||
            null;

        if (campaignVariant) {
            campaignVariant.color_hex = colorHex;
            campaignVariant.colorHex = colorHex;
            campaignVariant.hex = colorHex;
        }

        if (this.teeinbluePreview) {
            this.teeinbluePreview.style.setProperty(
                '--dp-teeinblue-preview-color',
                colorHex
            );
        }
    }

    getTeeinblueVariantScopes() {
        const roots = [
            this.teeinblueFormContainer,
            document.querySelector('#teeinblue-form'),
            this.getTeeinblueNativeForm(),
            this.getTeeinblueArtworkRoot()?.parentElement
        ].filter(Boolean);

        const selectors = [
            '.tee-block.tee-variants',
            '.tee-variants',
            '[data-tee-variants]',
            '[class*="variant-selector" i]',
            '[class*="variant-picker" i]',
            '[class*="product-options" i]'
        ];

        const scopes = [];

        roots.forEach((root) => {
            selectors.forEach((selector) => {
                if (root.matches?.(selector)) {
                    scopes.push(root);
                }

                root.querySelectorAll?.(selector).forEach((scope) => {
                    scopes.push(scope);
                });
            });
        });

        const uniqueScopes = Array.from(new Set(scopes));

        if (uniqueScopes.length > 0) {
            return uniqueScopes;
        }

        return roots;
    }

    getTeeinblueControlCandidates(control, scope) {
        const values = [
            control.value,
            control.textContent,
            control.getAttribute?.('aria-label'),
            control.getAttribute?.('title'),
            control.getAttribute?.('data-title'),
            control.getAttribute?.('data-value'),
            control.getAttribute?.('data-option-value'),
            control.dataset?.title,
            control.dataset?.value,
            control.dataset?.optionValue
        ];

        if (control.id) {
            const label =
                scope.querySelector?.(`label[for="${this.cssEscape(control.id)}"]`) ||
                document.querySelector(`label[for="${this.cssEscape(control.id)}"]`);

            values.push(label?.textContent);
        }

        return values
            .filter(Boolean)
            .map((value) => this.normalizeText(value))
            .filter(Boolean);
    }

    teeinblueCandidateMatches(candidate, target) {
        if (candidate === target) {
            return true;
        }

        const cleanedCandidate = candidate
            .replace(/\s*\([^)]+\)\s*/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();

        if (cleanedCandidate === target) {
            return true;
        }

        return (
            cleanedCandidate.startsWith(`${target} `) ||
            cleanedCandidate.endsWith(` ${target}`) ||
            cleanedCandidate.includes(` ${target} `)
        );
    }

    async applyTeeinblueOptionValue(root, targetValue) {
        if (!targetValue) {
            return false;
        }

        const normalizedTarget = this.normalizeText(targetValue);
        const scopes = this.getTeeinblueVariantScopes();

        for (const scope of scopes) {
            const radioInputs = Array.from(
                scope.querySelectorAll(
                    'input[type="radio"], input[type="checkbox"][role="radio"]'
                )
            );

            const matchingRadio = radioInputs.find((input) => {
                return this.getTeeinblueControlCandidates(input, scope).some(
                    (candidate) => {
                        return this.teeinblueCandidateMatches(
                            candidate,
                            normalizedTarget
                        );
                    }
                );
            });

            if (matchingRadio) {
                if (!matchingRadio.checked) {
                    matchingRadio.click();

                    if (!matchingRadio.checked) {
                        matchingRadio.checked = true;
                        this.dispatchControlChange(matchingRadio);
                    }
                } else {
                    this.dispatchControlChange(matchingRadio);
                }

                await this.wait(90);
                return true;
            }

            const clickableControls = Array.from(
                scope.querySelectorAll(
                    'button, [role="radio"], [role="option"], [data-value], [data-option-value]'
                )
            ).filter((control) => {
                return !control.matches('input, select, option');
            });

            const matchingControl = clickableControls.find((control) => {
                return this.getTeeinblueControlCandidates(control, scope).some(
                    (candidate) => {
                        return this.teeinblueCandidateMatches(
                            candidate,
                            normalizedTarget
                        );
                    }
                );
            });

            if (matchingControl) {
                matchingControl.click();
                await this.wait(90);
                return true;
            }

            const selects = Array.from(scope.querySelectorAll('select'));

            for (const select of selects) {
                const option = Array.from(select.options).find((candidate) => {
                    const values = [
                        candidate.textContent,
                        candidate.value,
                        candidate.getAttribute('data-value')
                    ]
                        .filter(Boolean)
                        .map((value) => this.normalizeText(value));

                    return values.some((candidateValue) => {
                        return this.teeinblueCandidateMatches(
                            candidateValue,
                            normalizedTarget
                        );
                    });
                });

                if (option) {
                    if (select.value !== option.value) {
                        const valueSetter = Object.getOwnPropertyDescriptor(
                            HTMLSelectElement.prototype,
                            'value'
                        )?.set;

                        if (valueSetter) {
                            valueSetter.call(select, option.value);
                        } else {
                            select.value = option.value;
                        }
                    }

                    this.dispatchControlChange(select);
                    await this.wait(90);
                    return true;
                }
            }
        }

        window.__dpB2BVariantDebug = {
            target: targetValue,
            normalizedTarget,
            scopeCount: scopes.length,
            scopeTexts: scopes.slice(0, 6).map((scope) => {
                return String(scope.textContent || '')
                    .replace(/\s+/g, ' ')
                    .trim()
                    .slice(0, 500);
            })
        };

        console.warn(
            `Die native Motiv-Variante "${targetValue}" wurde nicht gefunden.`,
            window.__dpB2BVariantDebug
        );

        return false;
    }

    dispatchControlChange(control) {
        if (!control) {
            return;
        }

        control.dispatchEvent(new Event('input', { bubbles: true }));
        control.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setTeeinblueQuantity(quantity) {
        const safeQuantity = Math.max(1, Number(quantity) || 1);

        this.getTeeinblueQuantityInputs().forEach((input) => {
            input.value = String(safeQuantity);
            this.dispatchControlChange(input);
        });
    }

    normalizeText(value) {
        return String(value || '')
            .replace(/\s+/g, ' ')
            .replace(/-/g, '–')
            .trim()
            .toLowerCase();
    }

    cssEscape(value) {
        if (window.CSS && typeof window.CSS.escape === 'function') {
            return window.CSS.escape(value);
        }

        return String(value).replace(
            /([ !"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g,
            '\\$1'
        );
    }

    wait(milliseconds) {
        return new Promise((resolve) => {
            window.setTimeout(resolve, milliseconds);
        });
    }

    getTotalQuantity() {
        return this.quantityInputs.reduce((sum, input) => {
            const value = Number.parseInt(input.value, 10);
            return sum + (Number.isFinite(value) ? value : 0);
        }, 0);
    }

    getSizeSurchargeTotal() {
        return this.quantityInputs.reduce((sum, input) => {
            const quantity = Number.parseInt(input.value, 10) || 0;
            const surcharge = Number.parseFloat(input.dataset.surcharge) || 0;
            return sum + quantity * surcharge;
        }, 0);
    }

    parseVariantId(value) {
        if (!value) {
            return null;
        }

        const match = String(value).match(/(\d+)$/);

        if (!match) {
            return null;
        }

        const variantId = Number(match[1]);
        return Number.isSafeInteger(variantId) ? variantId : null;
    }

    getColorValue(colorHandle) {
        const button = this.colorButtons.find((colorButton) => {
            return colorButton.dataset.colorHandle === colorHandle;
        });

        return button?.dataset.colorValue || '#111111';
    }

    getSelectedItems() {
        return this.quantityInputs
            .map((input) => {
                const quantity = Number.parseInt(input.value, 10) || 0;
                const surcharge = Number.parseFloat(input.dataset.surcharge) || 0;

                return {
                    color: this.normalizeConfiguredLabel(input.dataset.color || ''),
                    colorHandle: input.dataset.colorHandle || '',
                    colorValue: this.getColorValue(input.dataset.colorHandle || ''),
                    size: this.normalizeConfiguredLabel(input.dataset.size || ''),
                    quantity,
                    surcharge,
                    surchargeVariantId: this.parseVariantId(
                        input.dataset.surchargeVariantId
                    )
                };
            })
            .filter((item) => item.quantity > 0);
    }

    getSelectedPrintPosition() {
        const selected = this.printPositionInputs.find((input) => input.checked);
        return selected ? selected.value : '';
    }

    getDisplayPrintPosition(position) {
        const rawPosition = String(position || '');
        const normalizedPosition = this.normalizeText(rawPosition);
        const hasFront =
            normalizedPosition.includes('vorder') ||
            normalizedPosition.includes('front');
        const hasBack =
            normalizedPosition.includes('rück') ||
            normalizedPosition.includes('ruck') ||
            normalizedPosition.includes('back');

        if (hasFront && hasBack && this.frontPrintLabel !== 'Vorderseite') {
            return `${this.frontPrintLabel} & Rückseite`;
        }

        if (hasFront && !hasBack) {
            return this.frontPrintLabel;
        }

        return rawPosition;
    }

    getTier(totalQuantity) {
        if (totalQuantity >= 100) {
            return '100+';
        }

        if (totalQuantity >= 50) {
            return '50–99';
        }

        if (totalQuantity >= 25) {
            return '25–49';
        }

        if (totalQuantity >= 10) {
            return '10–24';
        }

        if (totalQuantity >= 6) {
            return '6–9';
        }

        if (totalQuantity >= 1) {
            return '1–5';
        }

        return '';
    }

    normalizeTier(value) {
        return String(value)
            .replace(/-/g, '–')
            .replace(/\s/g, '')
            .toLowerCase();
    }

    findMatchingVariant(printPosition, tier) {
        const normalizedTier = this.normalizeTier(tier);

        return this.variants.find((variant) => {
            const options = variant.options || [];
            const variantPrintPosition = String(options[0] || '');
            const variantTier = this.normalizeTier(options[1] || '');

            return (
                variantPrintPosition === printPosition &&
                variantTier === normalizedTier
            );
        });
    }

    formatMoneyFromEuros(euros) {
        return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
        }).format(euros);
    }

    setText(element, value) {
        if (!element) {
            return;
        }

        const nextValue = String(value);

        if (element.textContent !== nextValue) {
            element.textContent = nextValue;
        }
    }

    updateAll() {
        const totalQuantity = this.getTotalQuantity();
        const printPosition = this.getSelectedPrintPosition();
        const tier = this.getTier(totalQuantity);

        this.updateQuantity(totalQuantity);
        this.updateMinimumWarning(totalQuantity);
        this.updateSummary(printPosition);
        this.updatePrice(totalQuantity, printPosition, tier);
        this.updateProjectOverview(totalQuantity, printPosition, tier);
        this.updateDeliveryTime(totalQuantity);
        this.updateArtworkStatus();
        this.updateCartButton(totalQuantity, printPosition, tier);
        this.updateOfferButton(totalQuantity, printPosition, tier);
        this.scheduleTeeinblueSync();
    }

    updateQuantity(totalQuantity) {
        this.setText(this.totalQuantityElement, `${totalQuantity} Stück`);

        this.quantityInputs.forEach((input) => {
            const quantity = Number.parseInt(input.value, 10) || 0;
            input.closest('.dp-b2b__size-field')?.classList.toggle(
                'has-quantity',
                quantity > 0
            );
        });

        const mobileQuantityText = `${totalQuantity} Stück`;

        this.setText(this.mobileQuantityElement, mobileQuantityText);
    }

    updateMinimumWarning(totalQuantity) {
        const missing = Math.max(this.minimumQuantity - totalQuantity, 0);
        const progressPercent = Math.min(
            100,
            Math.max(0, (totalQuantity / this.minimumQuantity) * 100)
        );

        if (this.minimumProgress) {
            const progressValueText = missing === 0
                ? `${totalQuantity} Stück ausgewählt, Bestellmenge gültig`
                : totalQuantity === 0
                    ? `Noch keine Stückzahl ausgewählt, bestellbar ab ${this.minimumQuantity} Stück`
                    : `${totalQuantity} von mindestens ${this.minimumQuantity} Stück ausgewählt, noch ${missing} Stück`;

            this.minimumProgress.setAttribute(
                'aria-valuenow',
                String(Math.min(totalQuantity, this.minimumQuantity))
            );
            this.minimumProgress.setAttribute(
                'aria-valuetext',
                progressValueText
            );
            this.minimumProgress.classList.toggle('is-reached', missing === 0);
        }

        if (this.minimumProgressBar) {
            this.minimumProgressBar.style.width = `${progressPercent}%`;
        }

        this.setText(
            this.minimumProgressText,
            missing === 0
                ? `${totalQuantity} Stück ausgewählt`
                : totalQuantity === 0
                    ? 'Noch keine Stückzahl ausgewählt'
                    : `${totalQuantity} von mindestens ${this.minimumQuantity} Stück ausgewählt`
        );

        this.setText(
            this.minimumProgressStatus,
            missing === 0
                ? '✓ Bestellmenge gültig'
                : totalQuantity === 0
                    ? `Bestellbar ab ${this.minimumQuantity} Stück`
                    : `Noch ${missing} Stück`
        );

        if (!this.minimumWarning) {
            return;
        }

        if (missing === 0) {
            this.minimumWarning.textContent = 'Bestellmenge gültig';
            this.minimumWarning.classList.add('is-reached');
            this.setText(this.mobileCartStatus, 'Bestellmenge gültig');
        } else {
            this.minimumWarning.textContent = totalQuantity === 0
                ? `Bitte mindestens ${this.minimumQuantity} Stück auswählen`
                : `Noch ${missing} Stück bis zur Mindestmenge`;
            this.minimumWarning.classList.remove('is-reached');
            this.setText(
                this.mobileCartStatus,
                totalQuantity === 0
                    ? 'Menge auswählen'
                    : `Noch ${missing} Stück auswählen`
            );
        }
    }

    updateSummary(printPosition) {
        if (
            !this.summaryElement ||
            !this.summaryEmptyElement ||
            !this.summaryBodyElement
        ) {
            return;
        }

        const items = this.getSelectedItems();
        this.updateArtworkVisibility();

        if (items.length === 0) {
            this.summaryElement.hidden = true;
            this.summaryEmptyElement.hidden = false;
            this.summaryBodyElement.innerHTML = '';

            if (this.summarySurchargeNote) {
                this.summarySurchargeNote.hidden = true;
            }
            return;
        }

        this.summaryElement.hidden = false;
        this.summaryEmptyElement.hidden = true;
        this.summaryBodyElement.innerHTML = '';

        this.setText(
            this.summaryPrintPositionElement,
            this.getDisplayPrintPosition(printPosition) || '–'
        );

        const normalizedPosition = String(printPosition).toLowerCase();
        let positionDescription =
            'Die gewählte Druckposition wird für alle Textilien übernommen.';

        if (
            normalizedPosition.includes('vorder') &&
            normalizedPosition.includes('rück')
        ) {
            positionDescription = this.frontPrintLabel === 'Vorderseite'
                ? 'Die Motive werden auf Vorder- und Rückseite gedruckt.'
                : 'Die Motive werden auf der Herzseite der Brust und auf der Rückseite gedruckt.';
        } else if (normalizedPosition.includes('rück')) {
            positionDescription =
                'Das Motiv wird auf der Rückseite der Textilien gedruckt.';
        } else {
            positionDescription = this.frontPrintLabel === 'Vorderseite'
                ? 'Das Motiv wird auf der Vorderseite der Textilien gedruckt.'
                : 'Das Motiv wird auf der Herzseite der Brust gedruckt.';
        }

        this.setText(this.summaryPrintDescriptionElement, positionDescription);
        this.setText(
            this.summaryBackgroundTreatment,
            this.getBackgroundTreatment()
        );

        let hasSurcharge = false;

        items.forEach((item) => {
            const row = document.createElement('tr');
            const surchargeText =
                item.surcharge > 0
                    ? `${this.formatMoneyFromEuros(item.surcharge)} je Stück`
                    : '–';

            if (item.surcharge > 0) {
                hasSurcharge = true;
            }

            row.innerHTML = `
                <td>
                    <span class="dp-b2b__summary-color">
                        <span
                            class="dp-b2b__summary-color-dot"
                            style="--dp-summary-color: ${this.escapeHtml(item.colorValue)}"
                            aria-hidden="true"
                        ></span>
                        <span>${this.escapeHtml(item.color)}</span>
                    </span>
                </td>
                <td>${this.escapeHtml(item.size)}</td>
                <td><strong class="dp-b2b__summary-quantity">${item.quantity}</strong></td>
                <td>${surchargeText}</td>
            `;

            this.summaryBodyElement.appendChild(row);
        });

        if (this.summarySurchargeNote) {
            this.summarySurchargeNote.hidden = !hasSurcharge;
        }
    }

    escapeHtml(value) {
        return String(value)
            .replaceAll('&', '&amp;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;')
            .replaceAll('"', '&quot;')
            .replaceAll("'", '&#039;');
    }

    calculatePrice(totalQuantity, printPosition, tier) {
        if (!tier) {
            return null;
        }

        const variant = this.findMatchingVariant(printPosition, tier);

        if (!variant) {
            return null;
        }

        const grossUnitPriceEuros = Number(variant.price) / 100;
        const baseTotalGrossEuros = grossUnitPriceEuros * totalQuantity;
        const surchargeTotalGrossEuros = this.getSizeSurchargeTotal();
        const grossTotalEuros = baseTotalGrossEuros + surchargeTotalGrossEuros;
        const includedVatEuros = grossTotalEuros * (19 / 119);
        const averageUnitPriceGrossEuros =
            totalQuantity > 0 ? grossTotalEuros / totalQuantity : 0;

        return {
            variant,
            grossUnitPriceEuros,
            baseTotalGrossEuros,
            surchargeTotalGrossEuros,
            includedVatEuros,
            grossTotalEuros,
            averageUnitPriceGrossEuros
        };
    }

    clearPriceDisplay(tier = '–') {
        this.setText(this.priceTierElement, tier);
        this.setText(this.unitPriceElement, '–');
        this.setText(this.basePriceElement, '–');
        this.setText(this.surchargePriceElement, '–');
        this.setText(this.subtotalPriceElement, '–');
        this.setText(this.totalPriceElement, '–');
        this.setText(this.vatPriceElement, '–');
        this.setText(this.grossTotalPriceElement, '–');
        this.setText(this.mobileTotalElement, '–');
    }

    updatePrice(totalQuantity, printPosition, tier) {
        if (!tier) {
            this.clearPriceDisplay();
            return;
        }

        const calculation = this.calculatePrice(
            totalQuantity,
            printPosition,
            tier
        );

        if (!calculation) {
            this.clearPriceDisplay(tier);
            this.setText(this.unitPriceElement, 'Variante fehlt');
            return;
        }

        this.setText(this.priceTierElement, tier);
        this.setText(
            this.unitPriceElement,
            this.formatMoneyFromEuros(calculation.averageUnitPriceGrossEuros)
        );
        this.setText(
            this.basePriceElement,
            this.formatMoneyFromEuros(calculation.baseTotalGrossEuros)
        );
        this.setText(
            this.surchargePriceElement,
            this.formatMoneyFromEuros(calculation.surchargeTotalGrossEuros)
        );
        this.setText(
            this.subtotalPriceElement,
            this.formatMoneyFromEuros(calculation.grossTotalEuros)
        );
        this.setText(
            this.totalPriceElement,
            this.formatMoneyFromEuros(calculation.grossTotalEuros)
        );
        this.setText(
            this.vatPriceElement,
            this.formatMoneyFromEuros(calculation.includedVatEuros)
        );
        this.setText(
            this.grossTotalPriceElement,
            this.formatMoneyFromEuros(calculation.grossTotalEuros)
        );
        this.setText(
            this.mobileTotalElement,
            this.formatMoneyFromEuros(calculation.grossTotalEuros)
        );
    }

    getNextTierTarget(totalQuantity) {
        if (totalQuantity < this.minimumQuantity) {
            return {
                quantity: this.minimumQuantity,
                label: 'Mindestmenge'
            };
        }

        if (totalQuantity < 6) {
            return { quantity: 6, label: 'Staffel ab 6 Stück' };
        }

        if (totalQuantity < 10) {
            return { quantity: 10, label: 'Staffel ab 10 Stück' };
        }

        if (totalQuantity < 25) {
            return { quantity: 25, label: 'Staffel ab 25 Stück' };
        }

        if (totalQuantity < 50) {
            return { quantity: 50, label: 'Staffel ab 50 Stück' };
        }

        if (totalQuantity < 100) {
            return { quantity: 100, label: 'Staffel ab 100 Stück' };
        }

        return null;
    }

    updateProjectOverview(totalQuantity, printPosition, tier) {
        this.setText(this.projectTextileElement, this.productLabel);
        this.setText(
            this.projectPrintElement,
            this.getDisplayPrintPosition(printPosition) || '–'
        );

        const hasSelection = totalQuantity > 0;

        if (!hasSelection) {
            this.setText(this.projectStatusElement, 'Noch keine Auswahl');
            this.setText(this.projectQuantityElement, '0 Stück');
            this.setText(this.projectUnitPriceElement, '–');
            this.setText(this.projectTotalPriceElement, '–');

            if (this.projectCompactPriceElement) {
                this.projectCompactPriceElement.textContent = '';
                this.projectCompactPriceElement.hidden = true;
            }

            this.setText(
                this.projectTierMessageElement,
                'Wählen Sie Größen und Mengen – der Preis aktualisiert sich automatisch.'
            );
            return;
        }

        const displayQuantity = totalQuantity;
        const displayTier = tier;
        const calculation = this.calculatePrice(
            displayQuantity,
            printPosition,
            displayTier
        );

        this.setText(this.projectStatusElement, 'Aktuelle Auswahl');
        this.setText(this.projectQuantityElement, `${totalQuantity} Stück`);

        if (calculation) {
            const unitPrice = calculation.averageUnitPriceGrossEuros;
            const totalPrice = calculation.grossTotalEuros;

            this.setText(
                this.projectUnitPriceElement,
                this.formatMoneyFromEuros(unitPrice)
            );
            this.setText(
                this.projectTotalPriceElement,
                this.formatMoneyFromEuros(totalPrice)
            );
            this.setText(
                this.projectCompactPriceElement,
                `${displayQuantity} Stück · ${this.formatMoneyFromEuros(totalPrice)}`
            );

            if (this.projectCompactPriceElement) {
                this.projectCompactPriceElement.hidden = false;
            }
        }

        const nextTier = this.getNextTierTarget(totalQuantity);

        if (!nextTier) {
            this.setText(
                this.projectTierMessageElement,
                'Beste verfügbare Preisstaffel erreicht.'
            );
            return;
        }

        const missing = Math.max(nextTier.quantity - totalQuantity, 0);

        if (totalQuantity < this.minimumQuantity) {
            this.setText(
                this.projectTierMessageElement,
                totalQuantity === 0
                    ? `Bestellbar ab ${this.minimumQuantity} Stück – größere Mengen werden automatisch günstiger.`
                    : `Noch ${missing} Stück bis zur Mindestmenge.`
            );
            return;
        }

        this.setText(
            this.projectTierMessageElement,
            `Noch ${missing} Stück bis zur günstigeren ${nextTier.label}.`
        );
    }

    updateDeliveryTime(totalQuantity) {
        const isLargeOrder = totalQuantity > 50;
        const productionTime = isLargeOrder ? '4–5 Werktage' : '2–3 Werktage';
        const shippingTime = '1–2 Werktage';
        const deliveryTime = isLargeOrder ? '5–7 Werktage' : '3–5 Werktage';

        this.setText(this.productionTimeElement, productionTime);
        this.setText(this.shippingTimeElement, shippingTime);
        this.setText(this.deliveryTimeElement, deliveryTime);
    }

    updateCartButton(totalQuantity, printPosition, tier) {
        if (!this.addToCartButton || this.isAddingToCart) {
            return;
        }

        const variant = tier
            ? this.findMatchingVariant(printPosition, tier)
            : null;
        const artworkValid = this.hasArtworkMethod();

        window.__dpB2BCartValidation = {
            totalQuantity,
            minimumQuantity: this.minimumQuantity,
            printPosition,
            tier,
            variantFound: Boolean(variant),
            variantAvailable: variant?.available !== false,
            artworkValid,
            artworkCompletionBySide: {
                ...this.artworkCompletionBySide
            }
        };

        const canAdd =
            totalQuantity >= this.minimumQuantity &&
            Boolean(printPosition) &&
            Boolean(variant) &&
            variant.available !== false &&
            artworkValid;

        this.addToCartButton.disabled = !canAdd;

        if (this.mobileAddToCartButton) {
            this.mobileAddToCartButton.disabled = !canAdd;
        }

        if (!this.cartMessage) {
            return;
        }

        this.cartMessage.classList.remove('is-error', 'is-success');

        if (totalQuantity < this.minimumQuantity) {
            const missing = this.minimumQuantity - totalQuantity;
            this.cartMessage.textContent =
                `Bitte wählen Sie noch ${missing} Stück aus.`;
            this.setText(this.mobileCartStatus, `Noch ${missing} Stück auswählen`);
            return;
        }

        if (!variant) {
            this.cartMessage.textContent =
                'Für diese Kombination wurde keine passende Shopify-Variante gefunden.';
            this.cartMessage.classList.add('is-error');
            this.setText(this.mobileCartStatus, 'Preiskombination nicht verfügbar');
            return;
        }

        if (variant.available === false) {
            this.cartMessage.textContent =
                'Diese Preis- und Druckvariante ist derzeit nicht verfügbar.';
            this.cartMessage.classList.add('is-error');
            this.setText(this.mobileCartStatus, 'Diese Auswahl ist nicht verfügbar');
            return;
        }

        if (!artworkValid) {
            this.cartMessage.textContent = this.printEmailCheckbox?.checked
                ? 'Bitte prüfen Sie die Angaben zu den Druckdaten.'
                : 'Bitte vervollständigen Sie die Motivgestaltung oder wählen Sie die Übermittlung per E-Mail.';
            this.setText(this.mobileCartStatus, 'Motivgestaltung noch abschließen');
            return;
        }

        this.cartMessage.textContent =
            'Die Konfiguration kann in den Warenkorb gelegt werden.';
        this.setText(this.mobileCartStatus, 'Bereit für den Warenkorb');
    }

    updateOfferButton(totalQuantity, printPosition, tier) {
        if (!this.downloadOfferButton) {
            return;
        }

        const variant = tier
            ? this.findMatchingVariant(printPosition, tier)
            : null;

        this.downloadOfferButton.disabled = !(
            totalQuantity >= this.minimumQuantity &&
            Boolean(printPosition) &&
            Boolean(variant)
        );
    }

    buildConfigurationText(items) {
        return items
            .map((item) => {
                return `${item.color}: ${item.size} – ${item.quantity} Stück`;
            })
            .join(' | ');
    }

    buildSurchargeCartItems(items, configurationId) {
        const surchargeQuantities = new Map();

        items.forEach((item) => {
            if (
                !item.surchargeVariantId ||
                item.surcharge <= 0 ||
                item.quantity <= 0
            ) {
                return;
            }

            const currentQuantity =
                surchargeQuantities.get(item.surchargeVariantId) || 0;

            surchargeQuantities.set(
                item.surchargeVariantId,
                currentQuantity + item.quantity
            );
        });

        return Array.from(surchargeQuantities.entries()).map(
            ([variantId, quantity]) => {
                return {
                    id: variantId,
                    quantity,
                    properties: {
                        '_B2B-Konfigurations-ID': configurationId,
                        '_Zugehöriger Artikel': 'Textil-Konfiguration'
                    }
                };
            }
        );
    }

    getMainProperties(
        printPosition,
        tier,
        totalQuantity,
        configurationText,
        configurationId,
        previewColorName
    ) {
        const properties = {
            'Druckposition': this.getDisplayPrintPosition(printPosition),
            'Preisstaffel': tier,
            'Farb- und Größenverteilung': configurationText,
            'Gesamtmenge': `${totalQuantity} Stück`,
            'Vorschaufarbe': previewColorName || '–',
            'Übermittlung der Druckdaten': this.getArtworkMethod(),
            '_B2B-Konfigurations-ID': configurationId
        };

        if (!this.printEmailCheckbox?.checked) {
            properties['Umgang mit dem Dateihintergrund'] =
                this.getBackgroundTreatment();
        }

        const notes = this.printNotesInput?.value.trim();

        if (notes) {
            properties['Anmerkungen zu den Druckdaten'] = notes;
        }

        return properties;
    }

    setCartLoading(isLoading) {
        this.isAddingToCart = isLoading;

        if (this.addToCartButton) {
            this.addToCartButton.disabled = isLoading;
        }

        if (this.mobileAddToCartButton) {
            this.mobileAddToCartButton.disabled = isLoading;
        }

        if (this.downloadOfferButton) {
            this.downloadOfferButton.disabled = isLoading;
        }

        if (this.cartLoader) {
            this.cartLoader.hidden = !isLoading;
        }

        if (this.mobileCartLoader) {
            this.mobileCartLoader.hidden = !isLoading;
        }

        if (this.cartButtonText) {
            this.cartButtonText.textContent = isLoading
                ? 'Wird hinzugefügt …'
                : 'Konfiguration in den Warenkorb';
        }

        if (this.mobileCartButtonText) {
            this.mobileCartButtonText.textContent = isLoading
                ? 'Wird hinzugefügt …'
                : 'In den Warenkorb';
        }
    }

    async addItemsAsJson(root, cartItems) {
        if (cartItems.length === 0) {
            return null;
        }

        const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ items: cartItems })
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(
                result.description ||
                result.message ||
                'Die Konfiguration konnte nicht hinzugefügt werden.'
            );
        }

        return result;
    }

    async fetchCart(root) {
        const response = await fetch(`${root}cart.js`, {
            headers: {
                'Accept': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Der Warenkorb konnte nicht geprüft werden.');
        }

        return response.json();
    }

    async restoreCartSnapshot(root, snapshot) {
        if (!snapshot || !Array.isArray(snapshot.items)) {
            return;
        }

        const currentCart = await this.fetchCart(root);
        const originalQuantities = new Map(
            snapshot.items.map((item) => [item.key, Number(item.quantity || 0)])
        );
        const updates = {};

        currentCart.items.forEach((item) => {
            updates[item.key] = originalQuantities.has(item.key)
                ? originalQuantities.get(item.key)
                : 0;
        });

        if (Object.keys(updates).length === 0) {
            return;
        }

        const response = await fetch(`${root}cart/update.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ updates })
        });

        if (!response.ok) {
            throw new Error('Der ursprüngliche Warenkorb konnte nicht wiederhergestellt werden.');
        }
    }

    async waitForCartIncrease(root, beforeCount, expectedIncrease, timeout = 20000) {
        const startedAt = Date.now();

        while (Date.now() - startedAt < timeout) {
            const cart = await this.fetchCart(root);
            const currentCount = Number(cart.item_count || 0);

            if (currentCount >= beforeCount + expectedIncrease) {
                return cart;
            }

            await this.wait(350);
        }

        throw new Error(
            'Die Motivgestaltung wurde nicht rechtzeitig an den Warenkorb übergeben. Bitte prüfen Sie die Pflichtfelder.'
        );
    }

    async waitForTeeinblueReady(
        timeout = 15000,
        requireEnabled = false
    ) {
        const startedAt = Date.now();

        while (Date.now() - startedAt < timeout) {
            this.installTeeinblueHooks();

            const root = this.getTeeinblueArtworkRoot();
            const button = this.getTeeinblueAtcButton();
            const buttonEnabled = Boolean(
                button &&
                !button.disabled &&
                button.getAttribute('disabled') === null &&
                button.getAttribute('aria-disabled') !== 'true' &&
                !button.classList.contains('loading') &&
                !button.classList.contains('is-loading')
            );

            if (
                root &&
                button &&
                (!requireEnabled || buttonEnabled)
            ) {
                return {
                    root,
                    button,
                    buttonEnabled
                };
            }

            await this.wait(150);
        }

        throw new Error(
            requireEnabled
                ? 'Vorder- und Rückseite wurden noch nicht vollständig von der Motivgestaltung übernommen.'
                : 'Der Gestaltungsbereich ist noch nicht vollständig geladen. Bitte laden Sie die Seite neu.'
        );
    }

    async waitForTeeinblueCustomizationApi(timeout = 15000) {
        const startedAt = Date.now();

        while (Date.now() - startedAt < timeout) {
            const api = window.teeinblue;

            if (typeof api?.createCustomization === 'function') {
                return api;
            }

            /*
                Bei der klassischen Shopify-Einbindung ist stattdessen der native
                Teeinblue-Warenkorbbutton vorhanden. Dann muss nicht bis zum Timeout
                auf die API der eingebetteten Ansicht gewartet werden.
            */
            if (this.getTeeinblueAtcButton()) {
                return null;
            }

            await this.wait(150);
        }

        return null;
    }

    addPropertiesToTeeinblueForm(properties) {
        const form =
            this.getTeeinblueNativeForm() ||
            this.variantBridgeForm;

        if (!form) {
            return;
        }

        form.querySelectorAll('[data-dp-b2b-property]').forEach((input) => {
            input.remove();
        });

        Object.entries(properties).forEach(([key, value]) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key}]`;
            input.value = String(value);
            input.setAttribute('data-dp-b2b-property', 'true');
            form.appendChild(input);
        });
    }

    openTeeinblueBridge(mainVariant, totalQuantity, properties) {
        this.installTeeinblueHooks();

        const bridge = window.__dpB2BTeeinblueBridge;

        if (!bridge) {
            throw new Error('Die Verbindung zur Motivgestaltung ist nicht verfügbar.');
        }

        const transformLineItem = (lineItem) => {
            const nextItem = {
                ...(lineItem || {}),
                id: Number(mainVariant.id),
                quantity: totalQuantity,
                properties: {
                    ...((lineItem && lineItem.properties) || {}),
                    ...properties
                }
            };

            if ('variant_id' in nextItem) {
                nextItem.variant_id = Number(mainVariant.id);
            }

            return nextItem;
        };

        bridge.active = {
            transform: (input) => {
                if (!input || typeof input !== 'object' || Array.isArray(input)) {
                    return input;
                }

                if (Array.isArray(input.items)) {
                    let transformed = false;
                    const items = input.items.map((item, index) => {
                        const itemId = Number(item?.id || item?.variant_id || 0);
                        const isSelectedVariant = itemId === Number(mainVariant.id);

                        if (!transformed && (isSelectedVariant || index === 0)) {
                            transformed = true;
                            return transformLineItem(item);
                        }

                        return item;
                    });

                    return {
                        ...input,
                        items
                    };
                }

                return transformLineItem(input);
            }
        };
    }

    closeTeeinblueBridge() {
        if (window.__dpB2BTeeinblueBridge) {
            window.__dpB2BTeeinblueBridge.active = null;
        }
    }

    async addMainItemViaTeeinblue(
        root,
        mainVariant,
        totalQuantity,
        properties
    ) {
        this.isPreparingCartVariant = true;
        this.currentMainVariant = mainVariant;

        await this.syncTeeinblueVariant(true, true);

        const api = await this.waitForTeeinblueCustomizationApi(15000);

        if (api) {
            try {
                const customization = await api.createCustomization(totalQuantity);

                if (!customization?.id) {
                    throw new Error(
                        'Die Motivgestaltung hat keine gültige Konfigurations-ID zurückgegeben.'
                    );
                }

                const teeinblueProperties = {
                    ...((customization && customization.properties) || {})
                };

                /*
                    Diese beiden Eigenschaften sorgen dafür, dass die Bestellung in
                    Teeinblue sicher der gespeicherten Gestaltung zugeordnet wird –
                    auch wenn eine SDK-Konfiguration nur eine der beiden ausliefert.
                */
                if (!teeinblueProperties._customization_id) {
                    teeinblueProperties._customization_id = customization.id;
                }

                if (!teeinblueProperties.customization_id) {
                    teeinblueProperties.customization_id = customization.id;
                }

                const teeinblueAddonItems = Array.isArray(
                    customization.addonVariants
                )
                    ? customization.addonVariants
                            .map((item) => ({
                                ...item,
                                id: Number(item.id),
                                quantity: Math.max(1, Number(item.quantity) || 1)
                            }))
                            .filter((item) => Number.isSafeInteger(item.id))
                    : [];

                await this.addItemsAsJson(root, [
                    {
                        id: Number(mainVariant.id),
                        quantity: totalQuantity,
                        properties: {
                            ...teeinblueProperties,
                            ...properties
                        }
                    },
                    ...teeinblueAddonItems
                ]);

                return this.fetchCart(root);
            } finally {
                this.isPreparingCartVariant = false;

                window.setTimeout(() => {
                    this.lastTeeinblueSyncKey = '';
                    this.scheduleTeeinblueSync(true);
                }, 120);
            }
        }

        const ready = await this.waitForTeeinblueReady(15000, true);

        this.setTeeinblueQuantity(totalQuantity);
        this.addPropertiesToTeeinblueForm(properties);
        this.openTeeinblueBridge(mainVariant, totalQuantity, properties);

        const beforeCart = await this.fetchCart(root);
        const beforeCount = Number(beforeCart.item_count || 0);

        ready.button.click();

        try {
            return await this.waitForCartIncrease(
                root,
                beforeCount,
                totalQuantity
            );
        } finally {
            this.closeTeeinblueBridge();
            this.isPreparingCartVariant = false;

            window.setTimeout(() => {
                this.lastTeeinblueSyncKey = '';
                this.scheduleTeeinblueSync(true);
            }, 120);
        }
    }

    async addConfigurationToCart() {
        if (this.isAddingToCart) {
            return;
        }

        const selectedItems = this.getSelectedItems();
        const totalQuantity = this.getTotalQuantity();
        const printPosition = this.getSelectedPrintPosition();
        const tier = this.getTier(totalQuantity);

        if (totalQuantity < this.minimumQuantity) {
            this.updateAll();
            return;
        }

        if (!this.hasArtworkMethod()) {
            this.setArtworkMessage(
                'Bitte vervollständigen Sie die Motivgestaltung oder bestätigen Sie die Übermittlung per E-Mail.',
                'error'
            );
            this.updateAll();
            return;
        }

        const currentColor = this.getCurrentPreviewColor();
        const selectedColorItem =
            selectedItems.find((item) => {
                return this.normalizeText(item.color) === this.normalizeText(currentColor.name);
            }) || selectedItems[0];

        if (
            selectedColorItem &&
            this.normalizeText(selectedColorItem.color) !==
                this.normalizeText(currentColor.name)
        ) {
            this.setPreviewColorByHandle(selectedColorItem.colorHandle);
            this.updateActivePreviewColor();
        }

        const cartColor = selectedColorItem
            ? {
                    name: selectedColorItem.color,
                    value: selectedColorItem.colorValue,
                    handle: selectedColorItem.colorHandle
                }
            : this.getCurrentPreviewColor();

        let mainVariant = null;

        try {
            mainVariant = await this.resolveVariant(
                printPosition,
                tier,
                cartColor.name
            );
        } catch (error) {
            if (this.cartMessage) {
                this.cartMessage.textContent = error.message;
                this.cartMessage.classList.add('is-error');
            }
            return;
        }

        if (!mainVariant) {
            if (this.cartMessage) {
                this.cartMessage.textContent =
                    'Die passende Hauptprodukt-Variante wurde nicht gefunden.';
                this.cartMessage.classList.add('is-error');
            }
            return;
        }

        this.currentMainVariant = mainVariant;
        this.currentResolvedVariant = mainVariant;
        this.synchronizeVariantBridge(mainVariant, cartColor);

        const missingSurchargeVariant = selectedItems.find((item) => {
            return item.surcharge > 0 && !item.surchargeVariantId;
        });

        if (missingSurchargeVariant) {
            if (this.cartMessage) {
                this.cartMessage.textContent =
                    `Für ${missingSurchargeVariant.size} fehlt die verknüpfte Aufpreis-Variante.`;
                this.cartMessage.classList.add('is-error');
            }
            return;
        }

        const configurationId =
            `B2B-${Date.now().toString(36).toUpperCase()}`;
        const configurationText = this.buildConfigurationText(selectedItems);
        const mainProperties = this.getMainProperties(
            printPosition,
            tier,
            totalQuantity,
            configurationText,
            configurationId,
            cartColor.name
        );
        const surchargeItems = this.buildSurchargeCartItems(
            selectedItems,
            configurationId
        );

        this.setCartLoading(true);

        if (this.cartMessage) {
            this.cartMessage.textContent = '';
            this.cartMessage.classList.remove('is-error', 'is-success');
        }

        const root = window.Shopify?.routes?.root || '/';
        let cartSnapshot = null;
        let cartMayHaveChanged = false;

        try {
            cartSnapshot = await this.fetchCart(root);

            if (this.printEmailCheckbox?.checked) {
                cartMayHaveChanged = true;
                await this.addItemsAsJson(root, [
                    {
                        id: Number(mainVariant.id),
                        quantity: totalQuantity,
                        properties: mainProperties
                    },
                    ...surchargeItems
                ]);
            } else {
                cartMayHaveChanged = true;
                await this.addMainItemViaTeeinblue(
                    root,
                    mainVariant,
                    totalQuantity,
                    mainProperties
                );

                await this.addItemsAsJson(root, surchargeItems);
            }

            if (this.cartMessage) {
                this.setText(
                    this.cartMessage,
                    'Die Konfiguration wurde hinzugefügt.'
                );
                this.cartMessage.classList.add('is-success');
            }

            window.location.href = `${root}cart`;
        } catch (error) {
            console.error('B2B-Warenkorbfehler:', error);
            this.closeTeeinblueBridge();

            if (cartMayHaveChanged && cartSnapshot) {
                try {
                    await this.restoreCartSnapshot(root, cartSnapshot);
                } catch (rollbackError) {
                    console.error(
                        'Der Warenkorb konnte nach dem Fehler nicht vollständig zurückgesetzt werden:',
                        rollbackError
                    );
                }
            }

            if (this.cartMessage) {
                this.setText(
                    this.cartMessage,
                    error.message ||
                        'Beim Hinzufügen ist ein Fehler aufgetreten.'
                );
                this.cartMessage.classList.add('is-error');
                this.cartMessage.classList.remove('is-success');
            }

            this.setCartLoading(false);
            this.updateAll();
        }
    }

    downloadOfferAsPdf() {
        const items = this.getSelectedItems();
        const totalQuantity = this.getTotalQuantity();
        const printPosition = this.getSelectedPrintPosition();
        const tier = this.getTier(totalQuantity);
        const calculation = this.calculatePrice(
            totalQuantity,
            printPosition,
            tier
        );

        if (
            totalQuantity < this.minimumQuantity ||
            !tier ||
            !calculation
        ) {
            return;
        }

        const date = new Intl.DateTimeFormat('de-DE', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        }).format(new Date());

        const lines = [
            { text: 'DESIGNPRINZ', size: 20, gapAfter: 4 },
            { text: 'Kunickerstr. 3 · 54411 Hermeskeil', size: 9 },
            { text: 'Telefon / WhatsApp: 06503 9534413', size: 9 },
            { text: 'E-Mail: info@designprinz.com', size: 9, gapAfter: 12 },
            { text: 'Angebot / Konfigurationsübersicht', size: 15, gapAfter: 14 },
            { text: `Erstellt am: ${date}`, size: 10 },
            {
                text: `Druckposition: ${this.getDisplayPrintPosition(printPosition)}`,
                size: 11
            },
            { text: `Druckdaten: ${this.getArtworkMethod()}`, size: 11 },
            ...(!this.printEmailCheckbox?.checked
                ? [{
                        text: `Dateihintergrund: ${this.getBackgroundTreatment()}`,
                        size: 11
                    }]
                : []),
            { text: `Gesamtmenge: ${totalQuantity} Stück`, size: 11 },
            { text: `Preisstaffel: ${tier}`, size: 11, gapAfter: 12 },
            { text: 'FARBEN, GRÖSSEN UND MENGEN', size: 12, gapAfter: 5 }
        ];

        items.forEach((item) => {
            const surcharge =
                item.surcharge > 0
                    ? ` | Aufpreis ${this.formatMoneyFromEuros(item.surcharge)} je Stück`
                    : '';

            lines.push({
                text: `${item.color} | ${item.size} | ${item.quantity} Stück${surcharge}`,
                size: 10
            });
        });

        lines.push(
            { text: '', size: 10, gapAfter: 6 },
            {
                text: `Warenwert: ${this.formatMoneyFromEuros(calculation.baseTotalGrossEuros)}`,
                size: 11
            },
            {
                text: `Größenaufpreise: ${this.formatMoneyFromEuros(calculation.surchargeTotalGrossEuros)}`,
                size: 11
            },
            {
                text: `Darin enthaltene MwSt. (19 %): ${this.formatMoneyFromEuros(calculation.includedVatEuros)}`,
                size: 11
            },
            {
                text: `Gesamtpreis inkl. MwSt.: ${this.formatMoneyFromEuros(calculation.grossTotalEuros)}`,
                size: 14,
                gapAfter: 12
            }
        );

        const notes = this.printNotesInput?.value.trim();

        if (notes) {
            lines.push(
                { text: 'ANMERKUNGEN', size: 12, gapAfter: 4 },
                { text: notes, size: 10, gapAfter: 10 }
            );
        }

        lines.push(
            {
                text: 'Dieses Dokument ist eine unverbindliche Konfigurationsübersicht. Maßgeblich sind die Preise und Angaben im Shopify-Warenkorb zum Zeitpunkt der Bestellung.',
                size: 9,
                gapAfter: 8
            },
            {
                text: 'DesignPrinz · Eigene Produktion in Deutschland · Qualität seit 1998',
                size: 9
            }
        );

        const pdfBytes = this.createPdfDocument(lines);
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `DesignPrinz-Angebot-${date.replaceAll('.', '-')}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    }

    createPdfDocument(sourceLines) {
        const pageWidth = 595;
        const pageHeight = 842;
        const left = 48;
        const top = 795;
        const bottom = 50;
        const maxChars = 88;
        const preparedLines = [];

        sourceLines.forEach((line) => {
            const wrapped = this.wrapPdfText(line.text, maxChars);
            wrapped.forEach((text, index) => {
                preparedLines.push({
                    text,
                    size: line.size || 10,
                    gapAfter:
                        index === wrapped.length - 1
                            ? line.gapAfter || 0
                            : 0
                });
            });
        });

        const pages = [];
        let currentPage = [];
        let y = top;

        preparedLines.forEach((line) => {
            const lineHeight = Math.max(line.size * 1.45, 14);

            if (y - lineHeight < bottom && currentPage.length > 0) {
                pages.push(currentPage);
                currentPage = [];
                y = top;
            }

            currentPage.push({
                ...line,
                x: left,
                y
            });

            y -= lineHeight + line.gapAfter;
        });

        if (currentPage.length > 0) {
            pages.push(currentPage);
        }

        const fontObjectNumber = 3 + pages.length * 2;
        const objectBytes = new Map();

        objectBytes.set(
            1,
            this.asciiBytes('<< /Type /Catalog /Pages 2 0 R >>')
        );

        const kids = pages
            .map((_, index) => `${3 + index * 2} 0 R`)
            .join(' ');

        objectBytes.set(
            2,
            this.asciiBytes(`<< /Type /Pages /Kids [${kids}] /Count ${pages.length} >>`)
        );

        pages.forEach((pageLines, index) => {
            const pageObjectNumber = 3 + index * 2;
            const contentObjectNumber = pageObjectNumber + 1;
            const content = this.createPdfContentStream(pageLines);

            objectBytes.set(
                pageObjectNumber,
                this.asciiBytes(
                    `<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ${pageWidth} ${pageHeight}] /Resources << /Font << /F1 ${fontObjectNumber} 0 R >> >> /Contents ${contentObjectNumber} 0 R >>`
                )
            );

            objectBytes.set(
                contentObjectNumber,
                this.concatBytes(
                    this.asciiBytes(`<< /Length ${content.length} >>\nstream\n`),
                    content,
                    this.asciiBytes('\nendstream')
                )
            );
        });

        objectBytes.set(
            fontObjectNumber,
            this.asciiBytes(
                '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>'
            )
        );

        const header = new Uint8Array([
            ...this.asciiBytes('%PDF-1.4\n%'),
            0xe2,
            0xe3,
            0xcf,
            0xd3,
            ...this.asciiBytes('\n')
        ]);

        const chunks = [header];
        const offsets = [0];
        let offset = header.length;

        for (let objectNumber = 1; objectNumber <= fontObjectNumber; objectNumber += 1) {
            const body = objectBytes.get(objectNumber);
            const prefix = this.asciiBytes(`${objectNumber} 0 obj\n`);
            const suffix = this.asciiBytes('\nendobj\n');
            const objectChunk = this.concatBytes(prefix, body, suffix);

            offsets[objectNumber] = offset;
            chunks.push(objectChunk);
            offset += objectChunk.length;
        }

        const xrefOffset = offset;
        const xrefLines = [
            'xref',
            `0 ${fontObjectNumber + 1}`,
            '0000000000 65535 f '
        ];

        for (let objectNumber = 1; objectNumber <= fontObjectNumber; objectNumber += 1) {
            xrefLines.push(
                `${String(offsets[objectNumber]).padStart(10, '0')} 00000 n `
            );
        }

        const trailer = this.asciiBytes(
            `${xrefLines.join('\n')}\ntrailer\n<< /Size ${fontObjectNumber + 1} /Root 1 0 R >>\nstartxref\n${xrefOffset}\n%%EOF`
        );

        chunks.push(trailer);
        return this.concatBytes(...chunks);
    }

    createPdfContentStream(lines) {
        const chunks = [];

        lines.forEach((line) => {
            chunks.push(
                this.asciiBytes(
                    `BT\n/F1 ${line.size} Tf\n1 0 0 1 ${line.x} ${line.y} Tm\n`
                )
            );
            chunks.push(this.pdfLiteralBytes(line.text));
            chunks.push(this.asciiBytes(' Tj\nET\n'));
        });

        return this.concatBytes(...chunks);
    }

    wrapPdfText(text, maxChars) {
        const normalized = String(text || '').replace(/\s+/g, ' ').trim();

        if (!normalized) {
            return [''];
        }

        const words = normalized.split(' ');
        const lines = [];
        let current = '';

        words.forEach((word) => {
            const candidate = current ? `${current} ${word}` : word;

            if (candidate.length > maxChars && current) {
                lines.push(current);
                current = word;
            } else {
                current = candidate;
            }
        });

        if (current) {
            lines.push(current);
        }

        return lines;
    }

    pdfLiteralBytes(text) {
        const bytes = [0x28];

        for (const character of String(text || '')) {
            const code = this.toWinAnsiByte(character);

            if (code === 0x28 || code === 0x29 || code === 0x5c) {
                bytes.push(0x5c);
            }

            bytes.push(code);
        }

        bytes.push(0x29);
        return new Uint8Array(bytes);
    }

    toWinAnsiByte(character) {
        const special = {
            '€': 0x80,
            '‚': 0x82,
            'ƒ': 0x83,
            '„': 0x84,
            '…': 0x85,
            '†': 0x86,
            '‡': 0x87,
            'ˆ': 0x88,
            '‰': 0x89,
            'Š': 0x8a,
            '‹': 0x8b,
            'Œ': 0x8c,
            'Ž': 0x8e,
            '‘': 0x91,
            '’': 0x92,
            '“': 0x93,
            '”': 0x94,
            '•': 0x95,
            '–': 0x96,
            '—': 0x97,
            '˜': 0x98,
            '™': 0x99,
            'š': 0x9a,
            '›': 0x9b,
            'œ': 0x9c,
            'ž': 0x9e,
            'Ÿ': 0x9f
        };

        if (Object.prototype.hasOwnProperty.call(special, character)) {
            return special[character];
        }

        const codePoint = character.codePointAt(0);

        if (codePoint <= 0xff) {
            return codePoint;
        }

        return 0x3f;
    }

    asciiBytes(value) {
        return new Uint8Array(
            Array.from(String(value), (character) => character.charCodeAt(0) & 0xff)
        );
    }

    concatBytes(...chunks) {
        const totalLength = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
        const result = new Uint8Array(totalLength);
        let offset = 0;

        chunks.forEach((chunk) => {
            result.set(chunk, offset);
            offset += chunk.length;
        });

        return result;
    }
}

function initializeDPB2B(scope = document) {
    scope.querySelectorAll('[data-dp-b2b]').forEach((element) => {
        if (element.dataset.initialized === 'true') {
            return;
        }

        element.dataset.initialized = 'true';
        new DPB2BConfigurator(element);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initializeDPB2B();
});

document.addEventListener('shopify:section:load', (event) => {
    initializeDPB2B(event.target);
});
